<template>
  <div>
    <v-snackbar
      v-model="progressBar"
      :timeout="-1"
      centered
      color="#ECEFF1"
      elevation="0"
    >
      <div class="d-flex justify-center">
        <v-progress-linear
          v-model="progressAdvance"
          buffer-value="0"
          stream
          color="pink"
          height="5"
          reactive
        />
      </div>
    </v-snackbar>
    
    <v-snackbar
      v-if="!loadingApplicationDialog"
      :value="$store.state.loadingApp > 0"
      centered
      elevation="0"
      color="transparent"
      timeout="-1"
    >
      <div class="d-flex justify-center">
        <v-progress-circular
          v-if="loadingAppProgress === 0"
          indeterminate
          color="pink"
          :value="loadingAppProgress"
          :width="8"
          :size="60"
        />
      </div>
    </v-snackbar>
    
    <v-snackbar
      v-model="alertSuccessMessage"
      :timeout="timeout"
      bottom
      color="success"
    >
      {{ successMessage }}
    </v-snackbar>

    <v-snackbar
      v-model="alertErrorMessage"
      :timeout="$store.state.timeout"
      bottom
      color="error"
    >
      {{ errorMessage }}
    </v-snackbar>

    <v-snackbar
      v-model="alertWarningMessage"
      :timeout="$store.state.timeout"
      bottom
      color="orange"
    >
      {{ warningMessage }}
    </v-snackbar>

    <v-snackbar
      :value="alertVPS"
      :timeout="$store.state.timeout"
      top
      color="error"
    >
      Package Maker is not connected!
    </v-snackbar>
    
    <v-snackbar
      :value="alertConnection"
      :timeout="$store.state.timeout"
      top
      color="error"
    >
      No connection with the database established!
    </v-snackbar>

    <nav>
      <v-app-bar
        flat
        clipped-left
      >
        <v-app-bar-nav-icon
          class="ppc_darkgreen--text text-darker-5"
          @click="drawer = !drawer"
        />
        <v-toolbar-title class="d-flex flex-row">
          <v-btn
            class="text-uppercase ppc_darkgreen--text"
            href="./"
            text
          >
            <span class="font-weight-light d-none d-md-inline display-1">Proyecto</span>
            <span class="d-none d-md-inline display-1">Peru</span>
            <span class="font-weight-bold d-flex d-md-none larger--text display-2">P</span>
          </v-btn>
          <v-card-subtitle class="mt-3">
            v{{ $store.state.version }} {{ $store.state.databaseName }}
          </v-card-subtitle>
        </v-toolbar-title>
        <v-spacer />
        <div class="mt-0 pt-4">
          <div class="d-flex flex-row">
            <v-btn 
              v-if="this.$route.name === 'TourAgenciesReport' || this.$route.name === 'CartaDePresentacion' || this.$route.name === 'PaymentAccommodationForm' || this.$route.name === 'AnnualReport' || this.$route.name === 'ClientApplicationForms'"
              color="ppc_darkgreen"
              class="white--text d-none d-sm-flex mb-1 mr-2"
              :disabled="$store.state.loadingApp > 0"
              small
              @click="goBack"
            >
              Back
            </v-btn>
            <v-btn
              v-if="this.$route.name === 'TourAgenciesReport' || this.$route.name === 'PaymentAccommodationForm'"
              color="ppc_darkgreen"
              class="white--text d-none d-sm-flex mb-1 mr-2"
              :disabled="$store.state.loadingApp > 0"
              small
              @click="openEmail"
            >
              Email
            </v-btn>
            <v-btn 
              v-if="this.$route.name === 'TourAgenciesReport' || this.$route.name === 'CartaDePresentacion' || this.$route.name === 'PaymentAccommodationForm' || this.$route.name === 'ClientApplicationForms'"
              color="ppc_darkgreen"
              class="white--text d-none d-sm-flex mb-1 mr-2"
              :disabled="$store.state.loadingApp > 0"
              small
              @click="printNow()"
            >
              Print/Download
            </v-btn>
          </div>
        </div>
        <v-snackbar
          v-model="alertLoggedOut"
          :timeout="$store.state.timeout"
          top
          color="success"
        >
          You are signed out, goodbye {{ $store.state.user }}!
        </v-snackbar>
        <v-snackbar
          v-model="alertLoggedIn"
          :timeout="$store.state.timeout"
          top
          color="success"
        >
          Welcome {{ $store.state.user }}!
        </v-snackbar>
        <v-spacer />
        <v-text-field
          v-model="searchString"
          placeholder="name, email, phone or client nr"
          filled
          rounded
          dense
          prepend-inner-icon="$vuetify.icons.icon_mdi_magnify"
          class="mt-7"
          style="width: 100px"
          clearable
          @click:prepend-inner="searchClient()"
          @keydown="checkSearchReturn($event)"
        />
        <div v-if="!statusLoggedOut">
          <span class="mx-5">
            <v-btn
              text
              @click="openPreferences"
            >
              <v-icon>$vuetify.icons.icon_mdi_account</v-icon>
              <span>
                {{ $store.state.user }}
              </span>
            </v-btn>
          </span>
          <span class="mx-5">
            <span class="font-weight-light d-none d-sm-inline">Sign Out</span>
            <v-btn
              icon
              color="font-weight-light"
              @click="onSignOut"
            >
              <v-icon>$vuetify.icons.icon_mdi_logout_variant</v-icon>
            </v-btn>
          </span>
        </div>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        mobile-breakpoint="600"
        expand-on-hover
        mini-variant
        app
        class="grey"
      >
        <div class="d-flex flex-column">
          <v-list>
            <v-list-item
              v-for="link in upperLinks"
              :key="link.text"
              @click="goView(link.route)"
            >
              <v-list-item-icon>
                <v-icon
                  v-if="link.text==='Package Maker' && `${alertMessagesPM}` > 0"
                  small
                  class="white--text"
                >
                  {{ alertMessagesPM }}
                </v-icon>
                <v-icon
                  v-else
                  small
                  class="white--text"
                >
                  {{ link.icon }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text">
                  {{ link.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider />
          <v-list>
            <v-list-item
              v-for="link in belowLinks"
              :key="link.text"
              @click="goView(link.route)"
            >
              <v-list-item-icon>
                <v-icon
                  :color="link.color"
                  small
                  class="white--text"
                >
                  {{ link.icon }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text">
                  {{ link.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
          </v-list>
          <v-list>
            <v-list-item
              v-for="link in partnerLinks"
              :key="link.text"
              @click="goView(link.route)"
            >
              <v-list-item-icon>
                <v-icon
                  small
                  class="white--text"
                >
                  {{ link.icon }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text">
                  {{ link.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
          </v-list>
        </div>
      </v-navigation-drawer>
    </nav>

    <v-dialog 
      v-model="dialog_preferences"
      :retain-focus="false"
      max-width="320px"
    >
      <v-flex>
        <v-card>
          <v-card-title>
            Preferences
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form @submit.prevent="onChangePreferences">
                <v-flex>
                  <v-text-field
                    id="newPassword"
                    v-model="newPassword"
                    name="newPassword"
                    label="Change Password"
                    filled
                    rounded
                    dense
                    :rules="passwordRules"
                    :error-messages="errorMessagePassword"
                    :type="passwordField ? 'password' : 'text'"
                    :append-icon="passwordField ? '$vuetify.icons.icon_mdi_eye' : '$vuetify.icons.icon_mdi_eye-off'"
                    @click:append="() => (passwordField = !passwordField)"
                    @blur="matchPassword"
                  />
                </v-flex>
                <v-flex>
                  <v-text-field
                    id="confirmPassword"
                    v-model="confirmPassword"
                    name="confirmPassword"
                    label="Confirm Password"
                    filled
                    rounded
                    dense
                    :error-messages="errorMessageConfirmPassword"
                    :type="confirmedPasswordField ? 'password' : 'text'"
                    :append-icon="confirmedPasswordField ? '$vuetify.icons.icon_mdi_eye' : '$vuetify.icons.icon_mdi_eye-off'"
                    @click:append="() => (confirmedPasswordField = !confirmedPasswordField)"
                    @blur="matchPassword"
                  />
                </v-flex>
                <v-flex>
                  Table Rows Shown
                  <v-select
                    v-model="itemsPerPageNew"
                    style="width: 200px"
                    :items="itemsPerPageList"
                    item-text="text"
                    item-value="value"
                    single-line
                    validate-on-blur
                    class="mr-4"
                  />
                  Default Currency Invoices
                  <v-select
                    v-model="showCurrencyNew"
                    style="width: 200px"
                    :items="currencyOptions"
                    item-text="text"
                    item-value="value"
                    single-line
                    validate-on-blur
                    class="mr-4"
                  />
                  <v-flex class="mt-4">
                    <div class="mb-2">
                      Dashboard Legend
                    </div>

                    <v-checkbox
                      v-for="type in legendTypes"
                      :key="type.value"
                      v-model="activeTypesLocal"
                      :label="type.text"
                      :value="type.value"
                      hide-details
                      dense
                    />
                  </v-flex>
                </v-flex>
                <div
                  v-if="this.$store.state.user === 'Coen'"
                  class="my-2"
                >
                  <v-btn @click="checkDB()">
                    Check DB
                  </v-btn>
                </div>

                <div
                  v-if="this.$store.state.user === 'Coen'"
                  class="my-2"
                >
                  <v-btn @click="doClasses()">
                    do Classes
                  </v-btn>
                </div>
                <div
                  v-if="this.$store.state.user === 'Coen'"
                  class="my-2"
                >
                  <v-btn @click="doClassGroups()">
                    do Class Groups
                  </v-btn>
                </div>
                <div
                  v-if="this.$store.state.user === 'Coen'"
                  class="my-2"
                >
                  <v-btn @click="doIncome()">
                    do Income
                  </v-btn>
                </div>
                <div
                  v-if="this.$store.state.user === 'Coen'"
                  class="my-2"
                >
                  <v-btn @click="doOutgoings()">
                    do Outgoings
                  </v-btn>
                </div>
                <div
                  v-if="this.$store.state.user === 'Coen'"
                  class="my-2"
                >
                  <v-btn @click="checkDistributionsOutgoings()">
                    check DistOut
                  </v-btn>
                </div>
                <v-flex
                  d-flex
                  justify-center
                >
                  <v-btn
                    color="ppc_darkgreen  white--text"
                    text
                    @click="dialog_preferences = !dialog_preferences"
                  >
                    Cancel
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    type="submit"
                    :disabled="loadingButton"
                    :loading="loadingButton"
                    color="ppc_darkgreen  white--text"
                    text
                  >
                    Save
                    <span
                      slot="loader"
                      class="custom-loader"
                    >
                      <v-icon light>$vuetify.icons.icon_mdi_cached</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-dialog>

    <v-dialog 
      v-model="dialog_email"
      :retain-focus="false"
      max-width="50vw"
    >
      <v-flex>
        <v-card>
          <v-card-title>
            Prepare your email
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form>
                <v-flex>
                  <v-text-field
                    v-model="emailList"
                    filled
                    rounded
                    label="to (seperated by commas)"
                  />
                  <v-text-field
                    v-model="emailSubject"
                    filled
                    rounded
                    label="subject"
                  />
                  <v-textarea
                    v-if="$store.state.emailMessage !== null"
                    v-model="emailIntro"
                    filled
                    rounded
                    dense
                    height="50vh"
                    no-resize
                    label="intro"
                  />
                </v-flex>
                
                <v-flex
                  d-flex
                  justify-center
                >
                  <v-btn
                    color="ppc_darkgreen  white--text"
                    text
                    @click="dialog_email = !dialog_email"
                  >
                    Cancel
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    color="ppc_darkgreen  white--text"
                    text
                    @click="sendEmail(false)"
                  >
                    Send
                  </v-btn>
                </v-flex>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-dialog>

    <v-dialog 
      v-model="statusLoggedOut"
      :retain-focus="false"
      max-width="320px"
      persistent
    >
      <v-flex>
        <v-card>
          <v-card-title>
            Sign In
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form @submit.prevent="onSignin">
                <v-flex mt-3>
                  <v-text-field
                    id="user"
                    v-model="user"
                    name="user"
                    label="User"
                    type="user"
                    filled
                    rounded
                    dense
                    required
                  />
                </v-flex>
                <v-flex>
                  <v-text-field
                    id="password"
                    v-model="password"
                    name="password"
                    label="Password"
                    filled
                    rounded
                    dense
                    :error-messages="errorMessagePasswordLogin"
                    :type="passwordFieldSignIn ? 'password' : 'text'"
                    :append-icon="passwordFieldSignIn ? '$vuetify.icons.icon_mdi_eye' : '$vuetify.icons.icon_mdi_eye-off'"
                    required
                    @click:append="() => (passwordFieldSignIn = !passwordFieldSignIn)"
                  />
                </v-flex>
                <v-flex
                  d-flex
                  justify-center
                >
                  <v-btn
                    type="submit"
                    :disabled="loadingButton || $store.state.loadingApp > 0"
                    :loading="loadingButton"
                    color="ppc_darkgreen white--text"
                  >
                    Sign in
                    <span
                      slot="loader"
                      class="custom-loader"
                    >
                      <v-icon light>$vuetify.icons.icon_mdi_cached</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
                <v-flex
                  d-flex
                  nowrap
                  justify-end
                > 
                  v{{ $store.state.version }}
                </v-flex>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-dialog>
    <v-dialog
      v-model="dialog_search"
      :retain-focus="false"
    >
      <v-data-table
        :headers="headersSearch"
        :items="searchResults"
        sort-by="Fullname"
        :items-per-page="-1"
        disable-pagination
        hide-default-footer
        class="pa-8"
      >
        <template v-slot:[`item.full_name`]="{ item }">
          <v-btn
            small
            rounded
            @click="goClient(item.id)"
          >
            {{ item.full_name }}
          </v-btn>
        </template>
        <template v-slot:[`item.gender`]="{ item }">
          <v-icon
            v-if="`${item.gender}` === 'Male'"
            small
            color="ppc_darkgreen"
          >
            fa-male
          </v-icon>
          <v-icon
            v-else-if="`${item.gender}` === 'Female'"
            small
            color="ppc_darkgreen"
          >
            fa-female
          </v-icon>
          <v-icon
            v-else
            small
            color="ppc_darkgreen"
          >
            fa-genderless
          </v-icon>
        </template>

        <template v-slot:[`item.start_first`]="{ item }">
          {{ formattedDate(item.start_first) }}
        </template>

        <template v-slot:[`item.statusClientId`]="{ item }">
          <v-chip
            small
            :color="getStatus(item.statusClientId).color"
            text-color="white"
          >
            {{ getStatus(item.statusClientId).name }}
          </v-chip>
        </template>

      </v-data-table>
    </v-dialog>

    <v-dialog
      v-model="dialogInvoice"
      :retain-focus="false"
      width="fit-content"
    >
      <div class="d-flex justify-space-around">
        <v-card 
          flat
          class="d-flex flex-column pa-12"
          width="210mm"
          min-height="297mm"
        >
          <span
            id="printSection"
            v-html="messageHTML"
          />
          <div class="d-flex flex-column invoiceButtons">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="ppc_pink"
                  fab
                  class="white--text mb-2 mt-6"
                  small
                  @click="dialogInvoice = false"
                  v-on="on"
                >
                  <v-icon color="white">
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>close</span>
            </v-tooltip>

            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="orange"
                  fab
                  class="white--text my-2"
                  small
                  @click="openEmail"
                  v-on="on"
                >
                  <v-icon color="white">
                    mdi-email
                  </v-icon>
                </v-btn>
              </template>
              <span>email</span>
            </v-tooltip>
              
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="blue"
                  fab
                  class="white--text my-2"
                  small
                  @click="printNow('invoice')"
                  v-on="on"
                >
                  <v-icon color="white">
                    mdi-printer
                  </v-icon>
                </v-btn>
              </template>
              <span>print/download</span>
            </v-tooltip>

            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="brown"
                  fab
                  class="white--text my-2"
                  small
                  :disabled="archiveInvoice"
                  @click="insertInvoice()"
                  v-on="on"
                >
                  <v-icon color="white">
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </template>
              <span>save to archive</span>
            </v-tooltip>
          </div>
          <div class="d-flex flex-column invoiceControlPanel">  
            <v-card
              v-if="showInvoiceControlPanel()"
              color="grey lighten-3"
              class="d-flex flex-column mt-6 pa-4 elevation-5 rounded-xl"
            >
              <v-checkbox 
                v-model="showTitleOnInvoice"
                label="Show app title"
                class="mt-0 pt-0"
                @change="createInvoice()"
              />
              <v-checkbox 
                v-model="includesPickup"
                label="Inludes Pickup"
                class="mt-0 pt-0"
                @change="createInvoice()"
              />
              <v-checkbox 
                v-model="includesSocialActivities"
                label="Includes Social Activities"
                class="mt-0 pt-0"
                @change="createInvoice()"
              />
              <v-checkbox 
                v-model="paymentRecommendation"
                label="Include payment recommendation"
                class="mt-0 pt-0"
                @change="createInvoice()"
              />
              <v-radio-group
                v-model="language"
                label="Language"
                column
                class="pa-0 ma-0"
                @change="createInvoice()"
              >
                <v-radio
                  label="English"
                  value="english"
                />
                <v-radio
                  label="Spanish"
                  value="spanish"
                />
              </v-radio-group>
              <v-radio-group
                v-model="groupBy"
                label="Group by"
                column
                class="pa-0 ma-0"
                @change="createInvoice()"
              >
                <v-radio
                  label="Client"
                  value="full_name"
                />
                <v-radio
                  label="Service"
                  value="name"
                />
                <v-radio
                  label="Type"
                  value="type"
                />
              </v-radio-group>
              <v-radio-group
                v-model="showCurrency"
                label="Total payment"
                column
                class="pa-0 ma-0"
                @change="createInvoice()"
              >
                <v-radio
                  label="Dollars only"
                  value="dollars"
                />
                <v-radio
                  label="Soles only"
                  value="soles"
                />
                <v-radio
                  label="Both"
                  value="both"
                />
              </v-radio-group>
              <v-checkbox 
                v-model="addDeposit"
                label="Add Deposit"
                class="mt-0 pt-0"
                :disabled="
                  updatedApplication.pass_to_planning ||
                    updatedApplication.depositTotal === 0 
                "
                @change="createInvoice()"
              />
              <v-checkbox 
                v-model="showWisePayment"
                label="Show Wise (eng)"
                class="mt-0 pt-0"
                :disabled="this.noRates"
                @change="createInvoice()"
              />
              <v-checkbox 
                v-model="showCreditCardPayment"
                label="Show Culqi Link"
                class="mt-0 pt-0"
                @change="createInvoice()"
              />
              <v-checkbox 
                v-model="showSolesPayment"
                label="Show Soles Acc"
                class="mt-0 pt-0"
                :disabled="showCurrency==='dollars'"
                @change="createInvoice()"
              />
              <v-checkbox 
                v-model="showCurrentBalance"
                label="Show Current Balance"
                class="mt-0 pt-0"
                @change="createInvoice()"
              />
            </v-card>
          </div>
        </v-card>
      </div>
    </v-dialog>

    <v-dialog
      v-model="dialogApplication"
      scrollable
      width="90vw"
    >
      <v-card
        flat
        class="d-flex justify-space-around rounded-xl"
        style="max-width: 100%;"
        color="#688f69"
      >
        <v-card
          v-if="updatedApplication.id !== null"
          flat
          class="d-flex flex-column px-16 pt-12 pb-4"
          color="#688f69"
          style="width: 100%"
        >
          <div
            class="d-flex flex-column justify-center"
            style="width: 100%"
          >
            <v-text-field
              v-model="updatedApplication.appTitle"
              class="center-text"
              rounded
              outlined
              counter="100"
              :rules="inputRules100maxReq"
              :disabled="updatedApplication.frozen"
              color="black"
              background-color="grey lighten-2"
              style="font-size: 24px; font-weight: bold"
              @change="updatedApplication.autoAppTitle = 0"
            />
          </div>
          <v-card
            flat
            class="d-flex flex-row flex-wrap"
            color="#688f69"
          >
            <v-card
              flat
              class="d-flex flex-column"
              color="#688f69"
            >
              <div class="caption white--text">
                Applied: {{ formattedDate(updatedApplication.applied) }}
              </div>
              <div class="caption white--text">
                Nr: {{ updatedApplication.id }}
              </div>
            </v-card>
            <v-spacer />
            <v-switch
              v-model="updatedApplication.autoAppTitle"
              class="mr-5"
              color="white"
              :disabled="updatedApplication.frozen || $store.state.loadingApp > 0"
              @change="changeAppTitle(updatedApplication)"
            >
              <template v-slot:label>
                <span
                  class="#688f69"
                  style="color: #FFF;"
                >Auto Title</span>
              </template>
            </v-switch>
            <v-switch
              v-model="updatedApplication.frozen"
              class="mr-5"
              color="white"
              :disabled="($store.state.unfreezeApplication === 0 && updatedApplication.frozen) || $store.state.loadingApp > 0"
            >
              <template v-slot:label>
                <span
                  class="#688f69"
                  style="color: #FFF;"
                >Freeze Application</span>
              </template>
            </v-switch>
            <v-spacer />
            <div
              style="width: 320px"
              class="d-flex flex-column"
            >
              <div
                v-if="updatedApplication.statusAppId !== null"
                class="align-self-end"
              >
                <v-chip
                  :color="getStatusApp(updatedApplication.statusAppId).color"
                  class="mt-2"
                  text-color="white"
                  v-html="getStatusApp(updatedApplication.statusAppId).name"
                />
              </div>
            </div>
          </v-card>
        </v-card>
        <v-divider />
        <v-card-text style="height: 70vh;">
          <v-card
            flat
            class="d-flex flex-row flex-wrap justify-center"
            color="#688f69"
          >
            <v-card
              flat
              color="grey lighten-2"
              class="d-flex flex-column pa-5 my-5 mr-2 rounded-xl"
              style="min-width: 500px"
            >
              <v-card-title class="pa-0 py-2">
                Clients<span> ({{ servicesClientsList.length }})</span>
              </v-card-title>
              <div class="d-flex flex-column">
                <v-list
                  rounded
                  dense
                  color="grey lighten-2"
                >
                  <v-list-group
                    v-for="(client, id) in servicesClientsList"
                    :key="id"
                    v-model="client.active"
                    :value="false"
                    no-action
                    rounded
                  >
                    <template v-slot:activator>
                      <div class="d-flex flex-row">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn 
                              v-if="client.id !== updatedApplication.clientId"
                              x-small 
                              fab 
                              class="mx-2"
                              v-on="on"
                              @click="goClient(client.id)"
                            >
                              <v-icon x-small>
                                mdi-arrow-up-bold
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Open client {{ client.name }}</span>
                        </v-tooltip>
                        <v-list-item-content>
                          <v-list-item-title v-text="client.name" />
                        </v-list-item-content>
                      </div>
                    </template>

                    <v-list-item
                      v-for="(service) in client.services"
                      :key="service.id || service.name + '-' + index"
                    >
                      <v-list-item-content class="d-flex flex-row">
                        <v-list-item-subtitle>
                          {{ `${service.name} ${service.currency}${decUtil.format(service.price)}` }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
                <hr
                  class="my-4"
                  style="width: 100%"
                >
                <v-card-subtitle>
                  <div class="ma-2">
                    <v-chip color="blue lighten-3">
                      {{ `Total Clients: $${calcSumServicesPrice} (${decUtil.toPEN(calcSumServicesPrice, '$', updatedApplication.exchangeRate)} PEN)` }}
                    </v-chip>
                  </div>
                </v-card-subtitle>
              </div>
            </v-card>
            <v-card
              flat
              color="grey lighten-2"
              class="d-flex flex-column pa-5 my-5 mr-2 rounded-xl"
              style="width: 500px"
              :disabled="updatedApplication.frozen"
            >
              <v-card-title class="pa-0 py-2">
                Extra Charges
              </v-card-title>
              <v-card
                flat
                class="d-flex flex-column ma-2 pa-4 rounded-xl"
                color="grey lighten-2"
              >
                <v-card
                  v-for="(charge, indexExtraCharge) in extraCharge"
                  :key="indexExtraCharge"
                  class="d-flex flex-row flex-wrap pa-5 mb-3 rounded-xl"
                  color="grey lighten-3"
                >
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="mt-2 mr-2">
                        {{ indexExtraCharge + 1 }}.
                      </div>
                      <v-text-field
                        v-model="charge.title"
                        class="pa-0 mr-2"
                        label="Extra Charge"
                        background-color="grey lighten-3"
                        clearable
                        :disabled="updatedApplication.frozen"
                        @click:clear="charge.amount = null"
                        @change="checkExtraChargeNew(), calcTotalPrice()"
                      />
                    </div>
                    <div class="d-flex flex-row flex-wrap">
                      <div
                        class="mt-2"
                        style="width: 30px"
                      >
                        {{ charge.currency }}
                      </div>
                      <div style="width: 150px">
                        <v-text-field
                          v-model="charge.amount"
                          class="pa-0 mr-2"
                          label="amount"
                          background-color="grey lighten-3"
                          clearable
                          :disabled="updatedApplication.frozen"
                          @blur="formatChargeAmount(charge)"
                          @click:clear="charge.amount = null"
                          @change="checkExtraChargeNew(), calcTotalPrice()"
                        />
                      </div>
                      <v-radio-group
                        v-model="charge.currency"
                        row
                        class="mt-1 mx-2"
                        :disabled="updatedApplication.frozen"
                        @change="calcTotalPrice(), formatChargeAmount(charge)"
                      >
                        <v-radio
                          label="PEN"
                          value="S/."
                          class="my-0 py-0"
                        />
                        <v-radio
                          label="USD"
                          value="$"
                          class="my-0 py-0"
                        />
                      </v-radio-group>
                    </div>
                    <div
                      class="my-2"
                      style="width: 150px"
                    >
                      ( {{ calcOtherCurrency(charge.amount, charge.currency, updatedApplication.exchangeRate) }} )
                    </div>
                    <div class="d-flex">
                      <v-spacer />
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="grey"
                            v-bind="attrs"
                            dark
                            x-small
                            fab
                            class="mx-2 my-0"
                            :disabled="extraCharge.length === indexExtraCharge + 1 || updatedApplication.frozen"
                            v-on="on"
                            @click="removeExtraCharge(indexExtraCharge)"
                          >
                            <v-icon 
                              v-on="on"
                            >
                              $vuetify.icons.icon_mdi_delete
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Remove extra charge</span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-card>
                <hr
                  class="my-4"
                  style="width: 100%"
                >
                <v-card-subtitle>
                  <div class="ma-2">
                    <v-chip color="green lighten-3">
                      Total Extra Charges: ${{ calcSumExtraChargesUSD() }} ({{ calcSumExtraChargesPEN() }} PEN)
                    </v-chip>
                  </div>
                </v-card-subtitle>
              </v-card>
            </v-card>
            <v-card
              flat
              color="grey lighten-2"
              class="d-flex flex-column pa-5 my-5 mr-2 rounded-xl"
              style="width: 600px"
              :disabled="updatedApplication.frozen"
            >
              <v-card-title class="pa-0 py-2">
                Price Calculation
              </v-card-title>
              <v-card
                flat
                class="d-flex flex-row flex-wrap ma-2 pa-4 rounded-xl"
                color="orange lighten-3"
              >
                <div
                  class="ma-2"
                  style="width: 30px"
                >
                  {{ updatedApplication.currencyFixed }}
                </div>
                <div style="width: 100px">
                  <v-text-field
                    v-model="updatedApplication.fixedPrice"
                    class="pa-0 mr-2"
                    label="fixed at"
                    background-color="orange lighten-3"
                    clearable
                    @click:clear="updatedApplication.fixedPrice = null"
                    @change="calcTotalPrice()"
                  />
                </div>
                <v-radio-group
                  v-model="updatedApplication.currencyFixed"
                  row
                  class="mt-1 mx-2"
                  @change="calcTotalPrice()"
                >
                  <v-radio
                    label="PEN"
                    value="S/."
                    class="my-0 py-0"
                  />
                  <v-radio
                    label="USD"
                    value="$"
                    class="my-0 py-0"
                  />
                </v-radio-group>
                <div
                  v-if="updatedApplication.fixedPrice"
                  class="my-2"
                  style="width: 150px"
                >
                  ( {{ calcOtherCurrency(updatedApplication.fixedPrice, updatedApplication.currencyFixed, updatedApplication.exchangeRate) }} )
                </div>
              </v-card>
              <v-card
                flat
                class="d-flex flex-row flex-wrap ma-2 pa-4 rounded-xl"
                color="purple lighten-4"
              >
                <div
                  class="ma-2"
                  style="width: 30px"
                >
                  {{ updatedApplication.currencyRefund }}
                </div>
                <div style="width: 100px">
                  <v-text-field
                    v-model="updatedApplication.refund"
                    class="pa-0 mr-2"
                    label="refund"
                    background-color="purple lighten-4"
                    clearable
                    @click:clear="updatedApplication.refund = null"
                    @change="calcTotalPrice()"
                  />
                </div>
                <v-radio-group
                  v-model="updatedApplication.currencyRefund"
                  row
                  class="mt-1 mx-2"
                  @change="calcTotalPrice()"
                >
                  <v-radio
                    label="PEN"
                    value="S/."
                    class="my-0 py-0"
                  />
                  <v-radio
                    label="USD"
                    value="$"
                    class="my-0 py-0"
                  />
                </v-radio-group>
                <div
                  v-if="updatedApplication.refund"
                  class="my-2"
                  style="width: 150px"
                >
                  ( {{ calcOtherCurrency(updatedApplication.refund, updatedApplication.currencyRefund, updatedApplication.exchangeRate) }} )
                </div>
              </v-card>
              <v-card
                flat
                class="d-flex flex-column ma-2 pa-4 rounded-xl"
                color="cyan lighten-4"
              >
                <div class="d-flex flex-row flex-wrap">
                  <div
                    class="ma-2"
                    style="width: 30px"
                  >
                    {{ updatedApplication.currencyDiscount }}
                  </div>
                  <div style="width: 100px">
                    <v-text-field
                      v-model="updatedApplication.discount"
                      class="pa-0 mr-2"
                      label="discount"
                      background-color="cyan lighten-4"
                      clearable
                      @click:clear="updatedApplication.discount = null"
                      @change="updatedApplication.discountPercentage = null, calcTotalPrice()"
                    />
                  </div>
                  <v-radio-group
                    v-model="updatedApplication.currencyDiscount"
                    row
                    class="mt-1 mx-2"
                    :disabled="updatedApplication.discountPercentage !== null"
                    @change="calcTotalPrice()"
                  >
                    <v-radio
                      label="PEN"
                      value="S/."
                      class="my-0 py-0"
                    />
                    <v-radio
                      label="USD"
                      value="$"
                      class="my-0 py-0"
                    />
                  </v-radio-group>
                  <div
                    v-if="updatedApplication.discountPercentage || updatedApplication.discount"
                    class="my-2"
                    style="width: 150px"
                  >
                    ( {{ calcOtherCurrency(updatedApplication.discount, updatedApplication.currencyDiscount, updatedApplication.exchangeRate) }} )
                  </div>
                </div>
                <div class="d-flex flex-row flex-wrap">
                  <div style="width: 150px">
                    <v-text-field
                      v-model="updatedApplication.discountPercentage"
                      class="pa-0 mr-2"
                      label="percentage"
                      background-color="cyan lighten-4"
                      clearable
                      @click:clear="updatedApplication.discountPercentage = null"
                      @change="updatedApplication.currencyDiscount = '$', calcTotalPrice()"
                    />
                  </div>
                  <div class="caption mt-4">
                    % discount over the total price
                  </div>
                </div>
              </v-card>
              <v-card
                flat
                class="d-flex flex-column ma-2 pa-4 rounded-xl"
                color="grey lighten-2"
              >
                <hr
                  class="my-4"
                  style="width: 100%"
                >
                <v-card-subtitle>
                  <div
                    v-if="updatedApplication.fixedPrice === null"
                    class="ma-2"
                  >
                    <v-chip color="blue lighten-3">
                      Total Clients: ${{ calcSumServicesPrice }} ({{ decUtil.format(decUtil.toPEN(calcSumServicesPrice, '$', updatedApplication.exchangeRate),0) }} PEN)
                    </v-chip>
                  </div>
                  <div v-else>
                    <div class="ma-2">
                      <v-chip
                        color="blue lighten-3"
                        class="text-decoration-line-through"
                      >
                        Total Clients: ${{ calcSumServicesPrice }} ({{ decUtil.format(decUtil.toPEN(calcSumServicesPrice, '$', updatedApplication.exchangeRate),0) }} PEN)
                      </v-chip>
                    </div>
                    <div
                      v-if="updatedApplication.currencyFixed === '$'"
                      class="ma-2"
                    >
                      <v-chip color="orange lighten-3">
                        Fixed at: ${{ updatedApplication.fixedPrice }} ({{ decUtil.format(decUtil.toPEN(updatedApplication.fixedPrice, '$', updatedApplication.exchangeRate),0) }} PEN)
                      </v-chip>
                    </div>
                    <div
                      v-else
                      class="ma-2"
                    >
                      <v-chip color="orange lighten-3">
                        Fixed at: ${{ decUtil.toUSD(updatedApplication.fixedPrice, 'S/.', updatedApplication.exchangeRate) }} ({{ updatedApplication.fixedPrice }} PEN)
                      </v-chip>
                    </div>
                  </div>
                  <div v-if="updatedApplication.refund && updatedApplication.refund !== null">
                    <div
                      v-if="updatedApplication.currencyRefund === '$'"
                      class="ma-2"
                    >
                      <v-chip color="purple lighten-4">
                        Refund: - ${{ updatedApplication.refund }} (-{{ decUtil.format(decUtil.toPEN(updatedApplication.refund, '$', updatedApplication.exchangeRate),0) }} PEN)
                      </v-chip>
                    </div>
                    <div
                      v-else
                      class="ma-2"
                    >
                      <v-chip color="purple lighten-4">
                        Refund: - ${{ decUtil.format(decUtil.toUSD(updatedApplication.refund, 'S/.', updatedApplication.exchangeRate)) }} (-{{ updatedApplication.refund }} PEN)
                      </v-chip>
                    </div>
                  </div>
                  <div v-if="updatedApplication.discount && updatedApplication.discount !== null">
                    <div
                      v-if="updatedApplication.discount && updatedApplication.currencyDiscount === '$'"
                      class="ma-2"
                    >
                      <v-chip color="cyan lighten-4">
                        Discount: - ${{ updatedApplication.discount }} (-{{ decUtil.format(decUtil.toPEN(updatedApplication.discount, '$', updatedApplication.exchangeRate),0) }} PEN)
                      </v-chip>
                    </div>
                    <div
                      v-else
                      class="ma-2"
                    >
                      <v-chip color="cyan lighten-4">
                        Discount: - ${{ decUtil.format(decUtil.toUSD(updatedApplication.discount, 'S/.', updatedApplication.exchangeRate),0) }} (-{{ updatedApplication.discount }} PEN)
                      </v-chip>
                    </div>
                  </div>
                  <div
                    v-if="extraCharge.length > 1"
                    class="ma-2"
                  >
                    <v-chip color="green lighten-3">
                      Total Extra Charges: + ${{ calcSumExtraChargesUSD() }} ({{ calcSumExtraChargesPEN() }} PEN)
                    </v-chip>
                  </div>
                  <hr
                    class="my-4"
                    style="width: 60%"
                  >
                  <div class="ma-2">
                    <h3>Total: ${{ updatedApplication.totalPrice }} ( {{ decUtil.format(decUtil.toPEN(updatedApplication.totalPrice, '$', updatedApplication.exchangeRate),0) }} PEN)</h3>
                  </div>
                </v-card-subtitle>
              </v-card>
            </v-card>
            <v-card
              flat
              color="grey lighten-2 rounded-xl outlined"
              class="d-flex flex-column pa-5 my-5 mr-2"
              style="width: 700px"
            >
              <v-card-title class="pa-0 py-2 mb-8">
                Invoice
              </v-card-title>
              <v-card-subtitle class="pa-0">
                Payer
              </v-card-subtitle>
              <v-card
                flat
                class="d-flex flex-row flex-wrap"
                color="grey lighten-2"
              >
                <v-select
                  v-model="updatedApplication.payerClient"
                  style="width: 250px"
                  :items="servicesClientsList"
                  item-text="name"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="select"
                  single-line
                  prepend-icon="$vuetify.icons.icon_mdi_credit_card_outline ppc_darkgreen--text"
                  validate-on-blur
                  clearable
                  class="mr-4"
                  persistent-hint
                  hint="client"
                  :disabled="updatedApplication.amountPaidTransaction > 0"
                  @change="updatePayer('Client', $event)"
                />
                or
                <v-select
                  v-model="updatedApplication.payerAgency"
                  style="width: 250px"
                  :items="selectAvailableAgencies"
                  item-text="name"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="select"
                  single-line
                  prepend-icon="$vuetify.icons.icon_mdi_credit_card_outline ppc_darkgreen--text"
                  validate-on-blur
                  clearable
                  class="mr-4"
                  persistent-hint
                  hint="agency"
                  :disabled="updatedApplication.amountPaidTransaction > 0"
                  @change="updatePayer('Agency', $event)"
                />
              </v-card>
              <v-card-subtitle class="pa-0 mt-8">
                Or override name on invoice (first line will be title)
              </v-card-subtitle>
              <v-textarea
                v-model="updatedApplication.invoice_name"
                style="min-width: 300px"
                class="rounded-xl py-5"
                auto-grow
                clearable
                filled
                rounded
                shaped
                counter="255"
                rows="2"
                background-color="grey lighten-3"
                label="(255 max)"
                :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
              />
              <div class="d-flex flex-row flex-wrap justify-space-between">
                <div class="d-flex flex-column mx-4">
                  <v-card-subtitle class="pa-0 mt-0">
                    Includes Donations (USD)
                  </v-card-subtitle>
                  <v-text-field
                    v-model="updatedApplication.donationValueOnInvoice"
                    class="pa-0 mt-4"
                    style="width: 100px"
                    label="value"
                    background-color="grey lighten-3"
                    clearable
                    :disabled="updatedApplication.frozen"
                    @click:clear="updatedApplication.donationValueOnInvoice = null"
                  />
                </div>
                <div class="d-flex flex-column mx-4">
                  <v-card-subtitle class="pa-0 mt-0">
                    Date on Invoice
                  </v-card-subtitle>
                  <span style="width: 170px;">
                    <v-menu
                      transition="scale-transition"
                      offset-y
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formattedDate(updatedApplication.invoice_date)"
                          v-bind="attrs"
                          prepend-icon="$vuetify.icons.icon_mdi_calendar"
                          readonly
                          class="pa-0 mt-4"
                          :disabled="$store.state.loadingApp > 0"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="updatedApplication.invoice_date"
                        color="grey darken-2"
                        no-title
                        scrollable
                      />
                    </v-menu>
                  </span>
                </div>
              </div>
              <v-card-subtitle class="pa-0 py-2 mt-2">
                Comments on invoice
              </v-card-subtitle>
              <v-textarea
                v-model="updatedApplication.comments"
                style="min-width: 300px;"
                class="rounded-xl py-5"
                auto-grow
                clearable
                filled
                rounded
                shaped
                counter="255"
                rows="5"
                background-color="grey lighten-3"
                label="(255 max)"
                :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
              />
              <v-btn 
                color="blue" 
                class="ma-4 mb-8 mt-0" 
                :disabled="$store.state.loadingApp > 0 || (!updatedApplication.payerAgency && !updatedApplication.payerClient)" 
                @click="archiveInvoice = false, applicationId = updatedApplication.id, createInvoice()"
              >
                <v-icon color="grey lighten-2">
                  $vuetify.icons.icon_mdi_cogs
                </v-icon>
                <span class="white--text">Create a New Invoice</span>
              </v-btn>
              <v-card-subtitle class="pa-0 mt-0 mb-8">
                Invoice history
              </v-card-subtitle>
              <v-data-table
                :sort-by="['timestamp']"
                :sort-desc="[true]"
                :headers="headersInvoices"
                :items="invoicesOnApplication"
                disable-pagination
                hide-default-footer
                dense
                class="grey lighten-2"
              >
                <template v-slot:[`item.timestamp`]="{ item }">
                  {{ formattedDate(item.timestamp, 'dateTimeShort') }}
                </template>

                <template v-slot:[`item.price`]="{ item }">
                  <span v-if="item.price">${{ item.price }}</span>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        small
                        v-on="on"
                        @click="displayInvoice(item)"
                      >
                        $vuetify.icons.icon_mdi_magnify
                      </v-icon>
                    </template>
                    <span>Open Invoice</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
            <v-card class="d-flex flex-column my-5 pa-5 rounded-xl grey lighten-2">
              <v-card-title class="pa-0 py-2 mb-8">
                Payments & Current Balance
              </v-card-title>
              <v-data-table
                :headers="headersApplicationIncome"
                :items="applicationTransfers"
                disable-pagination
                hide-default-footer
                dense
                sort-by="paidOn"
                class="grey lighten-2"
              >
                <template v-slot:[`item.amountIncome`]="{ item }">
                  <span v-if="item.currencyIncome && item.amountIncome">{{ item.currencyIncome }} {{ decUtil.format(item.amountIncome) }}</span>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  <span> ${{ decUtil.format(item.amount) }}</span>
                </template>
                <template v-slot:[`item.paidOn`]="{ item }">
                  <span v-html="formattedDate(item.paidOn)" />
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        small
                        v-on="on"
                        @click="goFinancial(item)"
                      >
                        $vuetify.icons.icon_mdi_magnify
                      </v-icon>
                    </template>
                    <span>Save Application & Open Transfer in Financial</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <div
                v-if="updatedApplication.totalPrice"
                class="d-flex flex-column"
              >
                <v-btn 
                  v-if="(this.$store.state.accessFinancial || this.$store.state.accessCajaGrande)" 
                  :disabled="$store.state.loadingApp > 0 || (!updatedApplication.payerAgency && !updatedApplication.payerClient)" 
                  color="blue" 
                  class="ma-4" 
                  @click="addPayment(updatedApplication.id, 'dollars')"
                >
                  <v-icon color="grey lighten-2">
                    $vuetify.icons.icon_mdi_credit_card_outline
                  </v-icon>
                  <span class="white--text">Save Application & Add Payment</span>
                </v-btn>
                <v-btn 
                  v-if="(this.$store.state.accessFinancial || this.$store.state.accessCajaGrande)"
                  :disabled="$store.state.loadingApp > 0 || (!updatedApplication.payerAgency && !updatedApplication.payerClient)"
                  color="blue" 
                  class="ma-4" 
                  @click="addRefund(updatedApplication.id, '$')"
                >
                  <v-icon color="white">
                    $vuetify.icons.icon_mdi_credit_card_outline
                  </v-icon>
                  <span class="white--text">Save Application & Add Refund</span>
                </v-btn>
              </div>
              <div class="d-flex flex-column ml-8">
                <div class="d-flex flex-row flex-wrap">
                  <v-text-field
                    v-model="updatedApplication.exchangeRate"
                    class="pa-0 mt-2 mr-2"
                    label="exchange rate"
                    style="width: 50px"
                    disabled
                    @change="calcTotalPrice()"
                  />
                </div>
                <div class="d-flex flex-column mt-0">
                  <h3 class="my-2">
                    Current Balance
                  </h3>
                  <h4 class="black--text d-flex flex-row justify-space-between">
                    <span>Price:</span> 
                    <span>{{ decUtil.format(updatedApplication.totalPrice) }} USD</span>
                    <span>({{ decUtil.toPEN(updatedApplication.totalPrice, '$', updatedApplication.exchangeRate) }} PEN)</span>
                  </h4>
                  <h4
                    v-if="updatedApplication.amountPaidApplication"
                    class="black--text d-flex flex-row justify-space-between"
                  >
                    <span>Paid:</span>
                    <span>{{ decUtil.format(updatedApplication.amountPaidApplication) }} USD</span>
                    <span>({{ decUtil.toPEN(updatedApplication.amountPaidApplication, '$', updatedApplication.exchangeRate) }} PEN)</span>
                  </h4>
                  <div v-else>
                    <h4 class="black--text d-flex flex-row justify-space-between">
                      <span>Paid:</span>
                      <span>-</span>
                      <span>-</span>
                    </h4>
                  </div>
                  <hr>
                  <div v-if="applicationIsNotPaid(updatedApplication)">
                    <h3
                      v-if="formattedDate(updatedApplication.start_first_service, 'date') > formattedDate($store.state.today, 'date')"
                      class="d-flex flex-row justify-space-between"
                    >
                      <span>Open:</span>
                      <span class="ppc_darkgreen--text">
                        {{ getOpenAmount(updatedApplication) }} USD
                      </span>
                      <span class="ppc_darkgreen--text">
                        ({{ decUtil.toPEN(getOpenAmount(updatedApplication), '$', updatedApplication.exchangeRate) }} PEN)
                      </span>
                    </h3>
                    <h3
                      v-else
                      class="d-flex flex-row justify-space-between"
                    >
                      <span>Open:</span>
                      <FONT c-o-l-o-r="red">
                        <span class="ppc_darkgreen--text">
                          {{ getOpenAmount(updatedApplication) }} USD
                        </span>
                      </FONT>
                      <FONT c-o-l-o-r="red">
                        <span class="ppc_darkgreen--text">
                          ({{ decUtil.toPEN(getOpenAmount(updatedApplication), '$', updatedApplication.exchangeRate) }} PEN)
                        </span>
                      </FONT>
                    </h3>
                  </div>
                  <div v-else>
                    <FONT c-o-l-o-r="darkgreen">
                      <strong>ALL PAID</strong>
                    </FONT>
                  </div>
                </div>
                <div class="mt-4">
                  <span
                    v-if="(updatedApplication.depositTotal && updatedApplication.depositTotal !== null && updatedApplication.depositPaid === 0 || (updatedApplication.depositPaid === 1 && updatedApplication.pass_to_planning === 1)) || updatedApplication.payerAgency !== null"
                    class="d-flex flex-row"
                  >
                    <span
                      v-if="updatedApplication && updatedApplication.depositTotal"
                      class="mr-2"
                    >Deposit: {{ decUtil.format(updatedApplication.depositTotal) }} USD</span>
                  </span>
                  <p v-if="updatedApplication.depositPaid === 1 && updatedApplication.payerAgency === null && updatedApplication.pass_to_planning === 0">
                    Passed to planning (deposit paid)
                  </p>
                  <p v-if="updatedApplication.payerAgency !== null && updatedApplication.pass_to_planning === 1">
                    Passed to planning (agency)
                  </p>
                  <p v-if="updatedApplication.statusAppId === 4">
                    Planning blocked: check resources!
                  </p>
                  <div v-if="updatedApplication.transferFeeIncluded">
                    Transfer Fee Included
                  </div>
                  <div v-else>
                    Transfer Fee Not Included
                  </div>
                </div>
              </div>
            </v-card>
          </v-card>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            v-if="servicesClientsList.length === 0"
            class="mr-4"
            text
            color="white"
            x-large
            @click="deleteApplication(updatedApplication)"
          >
            Remove Application
          </v-btn>
          <v-spacer />
          <v-btn
            class="mr-4"
            text
            color="white"
            x-large
            @click="dialogApplication = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="mr-4"
            text
            color="white"
            x-large
            @click="saveApplication(updatedApplication, false)"
          >
            Save
          </v-btn>
          <v-btn
            class="mr-4"
            text
            color="white"
            x-large
            @click="saveApplication(updatedApplication, true)"
          >
            Save & Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import CryptoJS from 'crypto-js';
import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import getDateFromTimestamp from '../mixins/getDateFromTimestamp';
import getServicesApplied from '../mixins/getServicesApplied';
import radioGroups_filtered from '../mixins/radioGroups_filtered';
import options_filtered_selected from '../mixins/options_filtered_selected';
import compare from '../mixins/compare';
import getStatusApp from '../mixins/getStatusApp';
import zlib from 'zlib';
import { print } from 'html-to-printer';
import dayjs from 'dayjs';
import "dayjs/locale/es";
import createAppTitle from '../mixins/createAppTitle';
import decUtil from '@/utils/decimalUtils';

export default {

  mixins: [inputRules, formattedDate, getDateFromTimestamp, getServicesApplied, radioGroups_filtered, options_filtered_selected, compare, getStatusApp, createAppTitle],
    data() {
    return {
      decUtil,
      drawer: true,
      upperLinks: [
          { icon: '$vuetify.icons.icon_mdi_account_plus', text: 'Leads', route: '/Leads' },
          { icon: '$vuetify.icons.icon_mdi_account_multiple', text: 'Clients', route: '/Clients' },
          { icon: '$vuetify.icons.icon_mdi_package_variant', text: 'Package Maker', route: '/PackageMaker' },
          { icon: '$vuetify.icons.icon_mdi_dashboard_sales', text: 'Dashboard Sales', route: '/DashboardSales' },
          { icon: '$vuetify.icons.icon_mdi_file_document_multiple', text: 'Applications', route: '/Applications' },
          { icon: '$vuetify.icons.icon_mdi_archive_outline', text: 'Invoice Archive', route: '/Invoices' },
      ],
      belowLinks: [],
      partnerLinks: [],
      alertLoggedIn: false,
      alertLoggedOut: false,
      passwordField: String,
      confirmedPasswordField: String,
      passwordFieldSignIn: String,
      errorMessagePasswordLogin: '',
      errorMessagePassword: '',
      errorMessageConfirmPassword: '',
      user: '',
      password: '',
      newPassword: '',
      confirmPassword: '',
      dialog_preferences: false,
      alertSuccessMessage: false,
      alertErrorMessage: false,
      alertWarningMessage: false,
      timeout: 3000,
      path: null,
      emailIntro: null,
      emailSubject: null,
      emailList: null,
      dialog_email: false,
      searchResults: [],
      headersApplicationIncome: [
        { text: 'Payment On', value: 'paidOn' },
        { text: 'Method', value: 'paymentMethodName' },
        { text: 'Payment', value: 'amountIncome' },
        { text: 'Distributed', value: 'amount' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headersSearch: [
        { text: 'Full Name', align: 'start', value: 'full_name' },
        { text: 'Email', value: 'email' },
        { text: 'Gender', value: 'gender', width: "100px", sortable: false},
        { text: 'Nationality', value: 'nationality' },
        { text: 'Source/Agency', value: 'source' },
        { text: 'Start', value: 'start_first' },
        { text: 'Status', value: 'statusClientId' },
      ],
      headersInvoices: [
        { text: 'Saved On', align: 'start', value: 'timestamp', width: '120px'},
        { text: 'Payer', value: 'payerName' },
        { text: 'Application Status', value: 'status' },
        { text: 'Price USD', value: 'price'},
        { text: 'Comments', value: 'comments'},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      currencyOptions: [
        { text: 'Dollars', value: 'dollars' },
        { text: 'Soles', value: 'soles' },
        { text: 'Both', value: 'both' }
      ],
      dialog_search: false,
      searchString: null,
      dialogInvoice: false,
      messageHTML: '',
      groupBy: 'full_name',
      language: 'english',
      showWisePayment: true,
      addDeposit: false,
      showCreditCardPayment: true,
      showSolesPayment: false,
      showCurrentBalance: true,
      applicationId: null,
      dataSaveInvoice: {},
      archiveInvoice: false,
      showTitleOnInvoice: false,
      extraCharge: [],
      extraChargeToRemove: [],
      updatedApplication: {},
      servicesClientsList: [],
      dialogApplication: false,
      servicesInApp: [],
      applicationIncome: [],
      outgoingsApp: [],
      applicationTransfers: [],
      invoicesOnApplication: [],
      loadingApplicationDialog: false,
      includesSocialActivities: false,
      paymentRecommendation: true,
      includesPickup: false,
      itemsPerPageNew: null,
      showCurrencyNew: null,
      itemsPerPageList: [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
        { text: 'All', value: -1 },
      ],
      activeTypesLocal: [],
      appWithOnlyEnglish: false,

      legendTypes: [
        { text: 'Projects', value: 'project' },
        { text: 'Accommodation', value: 'accommodation' },
        { text: 'Spanish', value: 'spanish' },
        { text: 'Tours', value: 'tour' }
      ],
      noRates: false
    }
  },
  computed: {

      statusLoggedOut () {
        return this.$store.getters.statusLoggedOut
      },

      loadingApp () {
        return this.$store.getters.loadingApp
      },

      loadingAppProgress () {
        return this.$store.getters.loadingAppProgress
      },

      progressBar () {
        return this.$store.getters.progressBar
      },

      progressAdvance () {
        return this.$store.getters.progressAdvance
      },

      loadingButton () {
        return this.$store.getters.loadingButton
      },

      errorLogIn () {
        return this.$store.getters.errorLogIn
      },

      alertVPS () {
        return this.$store.getters.alertVPS
      },

      alertConnection () {
        return this.$store.getters.alertConnection
      },

      emailMessage () {
        return this.$store.getters.emailMessage
      },

      successMessage () {
        return this.$store.getters.successMessage
      },

      errorMessage () {
        return this.$store.getters.errorMessage
      },

      warningMessage () {
        return this.$store.getters.warningMessage
      },

      displaySuccessMessage () {
        return this.$store.getters.displaySuccessMessage
      },

      displayErrorMessage () {
        return this.$store.getters.displayErrorMessage
      },

      displayWarningMessage () {
        return this.$store.getters.displayWarningMessage
      },

      alertMessagesPM () {
        return this.$store.getters.messagesPM.length
      },

      accessMenu () {
        return this.$store.getters.accessMenu
      },

      showInvoice () {
          return this.$store.getters.showInvoice
      },

      showApplication () {
          return this.$store.getters.showApplication
      },

      itemsPerPage () {
          return this.$store.getters.itemsPerPage
      },

      showCurrency () {
          return this.$store.getters.showCurrency
      },

      selectAvailableAgencies () {
          return this.$store.state.available_agencies.filter(function(select_item) {
              return select_item.obsolete === null;
          })
      },

      activeTypes: {
        get() {
          return this.$store.state.userPreferencesDashboard?.activeTypes || [
            'project', 'accommodation', 'spanish', 'tour'
          ];
        },
        set(val) {
          this.$store.commit('SET_ACTIVE_DASHBOARD_TYPES', val);
        }
      },

      calcSumServicesPrice () {

        let sumServicesPrice = this.decUtil.toDec(0);
        const exchangeRate = this.decUtil.toDec(this.$store.state.exchangeRate || 1);

        if (this.servicesInApp && this.servicesInApp.length > 0) {

          for (const service of this.servicesInApp) {

            if (!service.servicePrice) continue;

            const price = this.decUtil.toDec(service.servicePrice);

            const normalizedPrice =
              service.currency === "$"
                ? price
                : price.div(exchangeRate);

            sumServicesPrice = sumServicesPrice.plus(normalizedPrice);
          }
        }

        return this.decUtil.format(sumServicesPrice);

      },
      
    },

  // mounted() {
  //   setInterval(() => {
  //     this.$store.dispatch('checkWithPM');
  //   }, 600000);
  // },

  watch: {
    errorLogIn: function() {
      if (this.errorLogIn === null) {
          this.errorMessagePasswordLogin = ''
        } else {
          this.errorMessagePasswordLogin = this.errorLogIn
        }
    },
    statusLoggedOut(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.dialog_sign_in = false;
        this.alertLoggedIn = true;
        if (this.password === '123456') {
          this.dialog_preferences = true;
        }
      }
      if (newValue) {
        this.alertLoggedOut = true;
      }
    },
    alertVPS: function() {
      this.alertVPS = true;
    },
    alertConnection: function() {
      if (this.alertConnection) {
        this.alertConnection = true;
      }
    },
    emailMessage(newValue, oldValue) {
      console.log(newValue, oldValue)
      if (newValue.openEmailDialog) {
        this.openEmail();
      }
    },
    displaySuccessMessage: function () {
      if (this.successMessage !== "") {
        this.alertSuccessMessage = true;
      }
    },
    displayErrorMessage: function () {
      if (this.errorMessage !== "") {
        this.alertErrorMessage = true;
      }
    },
    displayWarningMessage: function () {
      if (this.warningMessage !== "") {
        this.alertWarningMessage = true;
      }
    },
    accessMenu() {
      this.belowLinks = [];
      if (this.$store.state.accessTeaching === 1 && this.$store.state.accessAccommodation === 1 && this.$store.state.accessProjects === 1 && this.$store.state.accessTours === 1) {
        this.belowLinks.push({ icon: '$vuetify.icons.icon_mdi_dashboard_ops', text: 'Dashboard Ops', route: '/DashboardOps', color: 'white' });
      }
      if (this.$store.state.accessTeaching === 1) {
        this.belowLinks.push({ icon: '$vuetify.icons.icon_languages', text: 'Teaching', route: '/Teaching' });
      }
      if (this.$store.state.accessAccommodation === 1) {
        this.belowLinks.push({ icon: '$vuetify.icons.icon_accommodation', text: 'Accommodation', route: '/Accommodation' });
      }
      if (this.$store.state.accessProjects === 1) {
        this.belowLinks.push({ icon: '$vuetify.icons.icon_volunteer', text: 'Projects', route: '/ProjectPlacements' });
      }
      if (this.$store.state.accessTours === 1) {
        this.belowLinks.push({ icon: '$vuetify.icons.icon_tours', text: 'Tours', route: '/TourAgencies' });
      }
      if (this.$store.state.accessFinancial === 1) {
        this.belowLinks.push({ icon: '$vuetify.icons.icon_mdi_cash_multiple', text: 'Financial', route: '/Financial' });
      }
      this.belowLinks.push(
        { icon: '$vuetify.icons.icon_mdi_cogs', text: 'Services', route: '/AvailableServices' },
      );
      

      this.partnerLinks = [];
      this.partnerLinks.push(
        { icon: '$vuetify.icons.icon_mdi_account_group', text: 'Contacts', route: '/Contacts' },
      );
      this.partnerLinks.push(
        { icon: '$vuetify.icons.icon_mdi_domain', text: 'Organisations', route: '/Organisations' },
      );
      this.partnerLinks.push(
        { icon: '$vuetify.icons.icon_mdi_domain_plus', text: 'Agencies', route: '/ClientAgencies' },
      );
      
    },

    showInvoice() {
      console.log("showInvoice", this.$store.getters.showInvoice);
      if (this.$store.getters.showInvoice) {
        this.displayInvoice(null);
      }
    },

    showApplication: function () {
      if (this.$store.getters.showApplication) {
        this.displayApplication();
      }
      this.$store.dispatch('showApplication', false);
    },

  },

    methods: {
      async goView(path) {
        if (this.$route.path !== path) {
          this.$router.push(path);
        }
      },
      
      matchPassword () {
        if (this.newPassword !== this.confirmPassword) {
          this.errorMessageConfirmPassword = 'Password does not match';
        } else {
          this.errorMessageConfirmPassword = '';
        }
      },
      
      async onSignin () {
        this.$store.dispatch('setLoadingButton', true)
        await this.$store.dispatch('clearError')
        let passhash = CryptoJS.SHA256(this.password).toString();
        const payload = {
          user: this.user,
          password: passhash,
        }
        await this.$store.dispatch('signUserIn', payload);
      },

      onSignOut () {
        this.$store.dispatch('signUserOut', true)
      },

      async printNow (form) {
        if (form === 'invoice') {
          print(this.messageHTML);
        } else {
          window.print();
          console.log('printNow #1b')
        }
      },

      openEmail () {
        this.getData();
        this.dialog_email = true;
      },

      getData() {
        this.submittedFrom = this.$store.state.emailMessage.submittedFrom;
        this.emailIntro = this.$store.state.emailMessage.emailIntro;
        this.emailSubject = this.$store.state.emailMessage.emailSubject;
        this.emailList = this.$store.state.emailMessage.emailList;
      },

      async sendEmail (sendDirect) {
        this.$store.dispatch('setLoadingApp', 1);
        if (sendDirect) {
          this.getData();
        }
        // this.messageHTMLOriginal = this.$store.state.emailMessage.messageHTML;
        
        let messageHTML = `
        <html>
          <body style="max-width: 21cm; margin: 20px; font-family: Raleway, Arial, Helvetica, sans-serif;">
            <span>${this.emailIntro}</span><br><br>
            ${this.$store.state.emailMessage.messageHTML}
          </body>
        </html>
        `;

        messageHTML = messageHTML.replace(/\n/g, "<br />");
        messageHTML = messageHTML.replace(/<google>/g, "<a href='https://www.google.com/search?q=proyecto%20peru&sxsrf=ALeKk01w0t_6jBUmS4wAhC6ShgbQb1O-XQ:1627373829160&source=hp&ei=_cD_YM-CAcGIafGcsfgO&iflsig=AINFCbYAAAAAYP_PDTqt8YGv_dAxkU83fnt5PQY_l9-S&oq=proye&gs_lcp=Cgdnd3Mtd2l6EAMYADIECCMQJzICCC4yAggAMgIIADICCAAyAggAMgUIABDLATICCAAyBQgAEMsBMgUIABDLAToECAAQQzoICC4QxwEQowI6BQgAEJECOgQIABAKUPYrWNYxYOM7aABwAHgAgAFjiAGFA5IBATWYAQCgAQGqAQdnd3Mtd2l6&sclient=gws-wiz&tbs=lrf:!1m4!1u3!2m2!3m1!1e1!1m4!1u2!2m2!2m1!1e1!1m4!1u16!2m2!16m1!1e1!1m4!1u16!2m2!16m1!1e2!2m1!1e2!2m1!1e16!2m1!1e3!3sIAE,lf:1,lf_ui:2&tbm=lcl&rflfq=1&num=10&rldimm=4342304706273858016&lqi=Cg1wcm95ZWN0byBwZXJ1SOjP9YbdgYCACFoVEAAYABgBIg1wcm95ZWN0byBwZXJ1kgEPbGFuZ3VhZ2Vfc2Nob29sqgEQEAEqDCIIcHJveWVjdG8oDg&ved=2ahUKEwiEuIP454LyAhUpsKQKHWmlC-AQvS4wDHoECBIQMg&rlst=f#rlfi=hd:;si:4342304706273858016,l,Cg1wcm95ZWN0byBwZXJ1SOjP9YbdgYCACFoVEAAYABgBIg1wcm95ZWN0byBwZXJ1kgEPbGFuZ3VhZ2Vfc2Nob29sqgEQEAEqDCIIcHJveWVjdG8oDg;mv:[[-6.1240304,-71.3310992],[-17.629842,-79.4959938]];tbs:lrf:!1m4!1u3!2m2!3m1!1e1!1m4!1u2!2m2!2m1!1e1!1m4!1u16!2m2!16m1!1e1!1m4!1u16!2m2!16m1!1e2!2m1!1e2!2m1!1e16!2m1!1e3!3sIAE,lf:1,lf_ui:2'>Google</a>")
        messageHTML = messageHTML.replace(/<facebook>/g, "<a href='https://www.facebook.com/ProyectoPeru'>Facebook</a>")
        messageHTML = messageHTML.replace(/<online classes>/g, "<a href='https://proyectoperucentre.org/online-spanish/'>Online Spanish Classes</a>")
        messageHTML = messageHTML.replace(/<Spanish Placement Test>/g, "<a href='https://docs.google.com/forms/d/e/1FAIpQLScV-3VQDsf8cHMz0ZTl9fTMbw1j-DG4Bth_DrxlXbVuYWD3mw/viewform'>Spanish Placement Test</a>")
        messageHTML = messageHTML.replace(/<information on tours>/g, "<a href='https://proyectoperucentre.org/tours/'>here</a>")
        messageHTML = messageHTML.replace(/<office email>/g, "<a href='office@proyectoperucentre.org'>office@proyectoperucentre.org</a>")
        messageHTML = messageHTML.replace(/<Application Form>/g, "<a href='https://proyectoperucentre.org/form'>Application Form</a>")
        let payload = {
          emailSubject: this.emailSubject,
          emailList: this.emailList,
          messageHTML: messageHTML,
          messagePlain: '',
          saveInvoice: this.$store.state.emailMessage.saveInvoice,
          attachments: this.$store.state.emailMessage.attachments,
          submittedFrom: this.submittedFrom,
        }
        this.dialog_email = false;
        this.$store.dispatch('setLoadingApp', 0);
        let result = await this.$store.dispatch('emailNow', payload);
        // console.log('sendEmail', result);
        if (result === 'OK' && this.archiveInvoice === false && this.$store.state.emailMessage.saveInvoice === true) {
          this.insertInvoice();
          this.archiveInvoice = true;
        }
        if (result === 'OK' && this.$route.name === 'TourAgencies') {
          let resources = this.$store.state.emailMessage.resources;
          const date = new Date();
          let today = date.getTime();
          let payload = {
              client: null,
              applications: null,
              services: null,
              radioGroups: null,
              radioOptions: null,
              options: null,
              resources: [],
          };
          for (let i = 0; i < resources.length; i++) {
            resources[i].info_to_provider = this.formattedDate(today, 'date');
            // await this.$store.dispatch('insertResource', resources[i]);
            payload.resources.push(resources[i]);
          }
          if (payload.resources.length > 0) {
            await this.$store.dispatch('insertUpdateMainItems', payload);
            await this.$store.dispatch('reloadResourcesTourAgencies', true);
          }
        }
      },

      async onChangePreferences () {
        if (this.newPassword.length > 0) {
          this.matchPassword();
          if (this.errorMessagePassword !== '' || this.errorMessageConfirmPassword !== '') {
            return
          } else {
            this.$store.dispatch('setLoadingButton', true)
            let passhash = CryptoJS.SHA256(this.newPassword).toString();
            let payloadPsw = {
              id: this.$store.state.uid,
              password: passhash,
            }
            await this.$store.dispatch('changePsw', payloadPsw)
          }
        }
        // console.log('onChangePreferences', this.itemsPerPageNew)
        if (this.itemsPerPageNew) {
          let payloadItems = {
            id: this.$store.state.uid,
            itemsPerPage: this.itemsPerPageNew,
          }
          await this.$store.dispatch('changeItemsPerPage', payloadItems)
        }
        if (this.showCurrencyNew) {
          let payloadItems = {
            id: this.$store.state.uid,
            showCurrency: this.showCurrencyNew,
          }
          await this.$store.dispatch('changeShowCurrency', payloadItems)
        }
        this.activeTypes = this.activeTypesLocal;
        this.$store.dispatch('saveDashboardPreferences', {
          activeTypes: this.activeTypesLocal
        });
        this.dialog_preferences = false;
      },

      goBack () {
        if (this.$store.state.breadcrumbs.length > 1) {
          console.log(this.$store.state.breadcrumbs[this.$store.state.breadcrumbs.length - 2])
          this.$router.push({ name: this.$store.state.breadcrumbs[this.$store.state.breadcrumbs.length - 2], params: { id: this.$store.state.client.id } })
        } else {
          this.$router.push({ name: this.$store.state.breadcrumbs[0] })
        }
      },
      
      async searchClient() {
        this.$store.dispatch('setLoadingApp', 1);
        this.searchResults = await this.$store.dispatch('searchClient', this.searchString)
        if (this.searchResults.length === 0) {
          this.$store.dispatch('warningMessage', 'No results found');
          this.$store.dispatch('setLoadingApp', 0);
        } else if (this.searchResults.length === 1) {
          this.goClient(this.searchResults[0].id)
        } else {
          for (let index = 0; index < this.searchResults.length; index++) {
            if(this.searchResults[index].agency_id !== null) {
              this.searchResults[index].source = this.$store.getters.agenciesById(this.searchResults[index].agency_id)[0].name;
            } else {
              this.searchResults[index].source = this.$store.getters.sourcesById(this.searchResults[index].source_id)[0].name;
            }
          }
          this.$store.dispatch('setLoadingApp', 0);
          this.dialog_search = true;
        }
      },

      checkSearchReturn(event) {
        if (event.code === 'Enter') {
          this.searchClient()
        }
      },

      goClient(id) {
        this.dialog_search = false;
        this.dialogApplication = false;
        if (this.$router.history.current.name === 'Client') {
          this.$store.dispatch('setLoadingApp', 1);
          this.$store.dispatch('changeCurrentClient', id);
        } else {
          this.$store.dispatch('setLoadingApp', 1);
          this.$router.push({ name: 'Client', params: { id: id } })
        }
      },

      getStatus(id) {
        const status = this.$store.state.statusClients.find(
          (select_item) => select_item.id === id
        );

        return status || {
          color: 'grey',
          name: 'Unknown'
        };
      },

      async createInvoice() {
        console.log('createInvoice', this.updatedApplication);
        // await this.saveApplication(this.updatedApplication, false);
        this.$store.dispatch('setLoadingApp', 1);
        let application = JSON.parse(JSON.stringify(this.updatedApplication)); 
        let services = JSON.parse(JSON.stringify(this.servicesInApp));
        let radioGroups = [];
        let options = [];
        let applicationIncome = this.applicationIncome;
        let applicationOutgoing = this.outgoingsApp;
        let extraCharge = JSON.parse(JSON.stringify(this.extraCharge));
        await Promise.all([ 
            radioGroups = await this.$store.dispatch('getRadioGroupsAppId', this.applicationId), 
            options = await this.$store.dispatch('getOptionsAppId', this.applicationId),
              ])
        console.log('createInvoice #1');
        if (this.showCurrency === 'dollars') {
          this.showSolesPayment = false;
        }
        // let currencyExtra = '$';
        // let servicePriceExtra = 0;
        let payload = {};
        if (extraCharge.length > 1) {
            extraCharge.splice(extraCharge.length - 1, 1);
            for (let i = 0; i < extraCharge.length; i++) {
              let amount = extraCharge[i].amount || 0;
              let currency = extraCharge[i].currency || '$';

              payload = {
                  name: extraCharge[i].title,
                  full_name: '',
                  type: '',
                  duration: '',
                  duration_text: '',
                  start: '',
                  desc_incl: '',
                  currency: currency,
                  servicePrice: Number(amount),
              }
              if (this.groupBy === "full_name") {
                if (this.language === 'english') {
                  payload.full_name = '';
                  payload.type = 'Extra';
                } else {
                  payload.full_name = '';
                  payload.type = 'Extra';
                }
              }
              if (this.groupBy === "name") {
                if (this.language === 'english') {
                  payload.full_name = 'Charge';
                  payload.type = 'Extra';
                } else {
                  payload.full_name = 'Carga';
                  payload.type = 'Extra';
                }
              }
              if (this.groupBy === "type") {
                if (this.language === 'english') {
                  payload.type = '';
                } else {
                  payload.type = '';
                }
              }
              services.push(payload);
            }
        }
        // console.log('createInvoice', services);
        for (let i = 0; i < services.length; i++) {
            if (services[i].desc_incl) {
              services[i].name += `, ${services[i].desc_incl}`;
            }
            if (radioGroups) {
                for (let j = 0; j < radioGroups.length; j++) {
                    if (radioGroups[j].services_id === services[i].id) {
                        services[i].name += ', ' + radioGroups[j].radio_group_value
                    }
                }
            }
            if (options) {
                for (let j = 0; j < options.length; j++) {
                    if (options[j].services_id === services[i].id && options[j].selected) {
                        services[i].name += ', ' + options[j].option_name
                    }
                }
            }
            // console.log('createInvoice', services[i].currency, services[i].servicePrice)
            if (!services[i].servicePrice) {
              services[i].servicePrice = 0;
            }
            if (services[i].currency === '$') {

              services[i].servicePriceUSD = this.decUtil.toDec(services[i].servicePrice).toFixed(2);
              services[i].servicePriceSoles = this.decUtil.toDec(services[i].servicePrice)
                .times(this.$store.state.exchangeRate)
                .toFixed(0);

            } else {

              services[i].servicePriceUSD = this.decUtil.toDec(services[i].servicePrice)
                .div(this.$store.state.exchangeRate)
                .toFixed(2);

              services[i].servicePriceSoles = this.decUtil.toDec(services[i].servicePrice).toFixed(0);
            }
        }
        let result = services.map((item) => {
            return {
                name: item.name,
                full_name: item.full_name,
                type: item.type,
                duration: `${item.duration} ${item.duration_text}`,
                start: this.formattedDate(item.start, "Noday"),
                end: this.formattedDate(item.end, "Noday"),
                priceUSD: `$${item.servicePriceUSD}`,
                priceSoles: `S/.${item.servicePriceSoles}`,
            };
        });
        this.dataSaveInvoice = {
            content: '',
            application_id: this.applicationId,
            payerClient: null,
            payerAgency: null,
            payerName: '',
            status: this.getStatusApp(application.statusAppId).name,
            appTitle: application.appTitle,
            price: this.decUtil.toDec(application.totalPrice).toFixed(2),
            comments: application.comments,
        };
        await this.getUser(application);
        let emailIntro = await this.getIntro(this.payer.name);
        // application.invoice_date = this.formattedDate(this.$store.state.today, 'date');
        // HTML version
        let messageHeader = "<table style='width: 100%; margin-top: 0cm; font-family: Raleway, Arial, Helvetica, sans-serif;'>" +
            "<tr style='height: 4cm'>" +
                "<td style='font-family: Roboto, sans-serif; font-size: 32px; color: #35b729; text-align: left; vertical-align: top; margin-bottom: 1cm;'><span>PROYECTO</span><strong>PERU</strong></td>" +
                "<td style='font-size: 32px; color: grey; text-align: right; vertical-align: top; margin-top: 5cm;'>"
                  if (this.language === 'english') {
                    dayjs.locale("en");
                    messageHeader += "<div>INVOICE</div>"
                    messageHeader += "<div style='font-size: 18px;'>" + 
                        dayjs(application.invoice_date).format("ddd MMM DD YYYY") + 
                    "</div>"
                  } else {
                    dayjs.locale("es");
                    messageHeader += "<div>RECIBO</div>"
                    let fecha = dayjs(application.invoice_date).format("ddd MMM DD YYYY");
                    messageHeader += "<div style='font-size: 18px;'>" + 
                        fecha + 
                    "</div>"
                  }
                    messageHeader += "<div style='font-size: 12px;'>refnr: " + 
                        this.getRefnr(application.id) +
                    "</div>" + 
                "</td>" + 
            "</tr>" + 
            "<tr style='height: 5cm'>" +
                "<td style='font-size: 14px; text-align: left; vertical-align: top;'>"

                  if (application.invoice_name) {

                    const formatted = application.invoice_name.replace(/\n/g, '<br/>');
                    const parts = formatted.split('<br/>');

                    application.invoice_title = parts[0] || '';
                    application.invoice_rest = parts.slice(1).join('<br/>') || '';

                    messageHeader += "<h3 style='color: grey;'>" + application.invoice_title + "</h3>";

                  } else if (this.payer.nameFormal) {

                    messageHeader += "<h3 style='color: grey;'>" + this.payer.nameFormal + "</h3>";

                  } else {

                    messageHeader += "<h3 style='color: grey;'>" + this.payer.name + "</h3>";
                  }


                  // Details block
                  if (!application.invoice_name) {

                    if (this.payer.idFormal) { messageHeader += "<div>Company number: " + this.payer.idFormal + "</div>" }
                    if (this.payer.address) { messageHeader += "<div>" + this.payer.address + "</div>" }
                    if (this.payer.country) { messageHeader += "<div>" + this.payer.country + "</div>" }
                    if (this.payer.phone) { messageHeader += "<div>" + this.payer.phone + "</div>" }
                    if (this.payer.nationality) { messageHeader += "<div>" + this.payer.nationality + "</div>" }
                    if (this.payer.email) { messageHeader += "<div>" + this.payer.email + "</div>" }

                  } else if (application.invoice_rest) {

                    messageHeader += "<div>" + application.invoice_rest + "</div>";

                  }
                messageHeader += "</td>" +
                "<td style='font-size: 14px; text-align: right; vertical-align: top;'>" + 
                    "<h3 style='color: grey;'>Proyecto Peru Centre S.A.C.</h3>" +
                    "<div>Avenida Arcopata 466-A</div>" +
                    "<div>Cusco, Cusco, 45</div>" +
                    "<div>+ 51 950 301 314</div>" +
                    "<div>info@proyectoperucentre.org</div>" +
                "</td>" +
                "</tr>" + 
        "</table>"
        var messageBody = '';
        /* ---------------- TITLE ---------------- */

        if (this.showTitleOnInvoice) {
          messageBody += `<h3>${application.appTitle}</h3><br>`;
        }

        /* ---------------- TABLE START ---------------- */

        let group = null;

        messageBody += `
          <div style="margin-bottom: 1cm; font-size: 12px;">
            <table style="width: 100%;">
        `;

        /* ============================================================
          GROUP BY FULL NAME
        ============================================================ */

        if (this.groupBy === 'full_name') {

          messageBody += `
            <colgroup>
              <col style="width:45%">
              <col style="width:20%">
              <col style="width:10%">
              <col style="width:10%">
              <col style="width:15%">
            </colgroup>
          `;

          result.sort(this.dynamicSort('full_name'));

          const groupTotals = {};

          for (const item of result) {
            const usdValue = parseFloat(String(item.priceUSD || 0).replace(/[^0-9.-]/g, '')) || 0;
            const penValue = parseFloat(
              String(item.priceSoles || 0)
                .replace('S/.', '')
                .replace(/,/g, '')
                .trim()
            ) || 0;

            if (!groupTotals[item.full_name]) {
              groupTotals[item.full_name] = {
                usd: 0,
                pen: 0,
              };
            }

            groupTotals[item.full_name].usd += usdValue;
            groupTotals[item.full_name].pen += penValue;
          }

          if (this.servicesClientsList.length === 0) {
            messageBody += this.language === 'english'
              ? `<tr>
                  <th style="text-align:left;text-indent:10px">Service</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th style="text-align:right">Price</th>
                </tr>`
              : `<tr>
                  <th style="text-align:left;text-indent:10px">Servicio</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th style="text-align:right">Precio</th>
                </tr>`;
          } else {
            messageBody += this.language === 'english'
              ? `<tr>
                  <th style="text-align:left;text-indent:10px">Service</th>
                  <th>Duration</th>
                  <th>From</th>
                  <th>Until</th>
                  <th style="text-align:right">Price</th>
                </tr>`
              : `<tr>
                  <th style="text-align:left;text-indent:10px">Servicio</th>
                  <th>Duración</th>
                  <th>Desde</th>
                  <th>Hasta</th>
                  <th style="text-align:right">Precio</th>
                </tr>`;
          }

          for (let row of result) {

            if (group !== row.full_name) {
              const totalDisplay =
                this.showCurrency === 'dollars'
                  ? `$${groupTotals[row.full_name].usd.toFixed(2)}`
                  : this.showCurrency === 'soles'
                    ? `S/. ${groupTotals[row.full_name].pen.toFixed(0)}`
                    : `$${groupTotals[row.full_name].usd.toFixed(2)} (S/. ${groupTotals[row.full_name].pen.toFixed(0)})`;

              messageBody += `
                <tr>
                  <td colspan="5" style="background-color:#EAECEE">
                    <div style="display:flex;justify-content:space-between;">
                      <strong>${row.full_name}</strong>
                      <strong>${totalDisplay}</strong>
                    </div>
                  </td>
                </tr>`;
              group = row.full_name;
            }

            const price =
              this.showCurrency === 'soles'
                ? row.priceSoles
                : this.showCurrency === 'dollars'
                  ? row.priceUSD
                  : `${row.priceUSD}<br><div style="color:grey;">(${row.priceSoles})</div>`;

            messageBody += `
              <tr>
                <td style="text-indent:10px">${row.name}</td>
                <td>${row.duration}</td>
                <td>${row.start}</td>
                <td>${row.end}</td>
                <td style="text-align:right">${price}</td>
              </tr>`;
          }
        }

        /* ============================================================
          GROUP BY NAME
        ============================================================ */

        if (this.groupBy === 'name') {

          const groupTotalsByName = {};

          for (const item of result) {
            const usdValue = parseFloat(String(item.priceUSD || 0).replace(/[^0-9.-]/g, '')) || 0;
            const penValue = parseFloat(
              String(item.priceSoles || 0)
                .replace('S/.', '')
                .replace(/,/g, '')
                .trim()
            ) || 0;

            if (!groupTotalsByName[item.name]) {
              groupTotalsByName[item.name] = {
                usd: 0,
                pen: 0,
              };
            }

            groupTotalsByName[item.name].usd += usdValue;
            groupTotalsByName[item.name].pen += penValue;
          }

          messageBody += `
            <colgroup>
              <col style="width:30%">
              <col style="width:25%">
              <col style="width:15%">
              <col style="width:15%">
              <col style="width:20%">
            </colgroup>
          `;

          result.sort(this.dynamicSort('name'));

          if (this.servicesClientsList.length === 0) {
            messageBody += this.language === 'english'
              ? `<tr>
                  <th style="text-indent:10px">Service</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>Price</th>
                </tr>`
              : `<tr>
                  <th style="text-indent:10px">Service</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>Precio</th>
                </tr>`;
          } else {
            messageBody += this.language === 'english'
              ? `<tr>
                  <th style="text-indent:10px">Client</th>
                  <th>Duration</th>
                  <th>From</th>
                  <th>Until</th>
                  <th>Price</th>
                </tr>`
              : `<tr>
                  <th style="text-indent:10px">Cliente</th>
                  <th>Duración</th>
                  <th>Desde</th>
                  <th>Hasta</th>
                  <th>Precio</th>
                </tr>`;
          }

          let amountOfClients = 0;

          for (let row of result) {

            amountOfClients++;

            if (group !== row.name) {

              if (group !== null) {
                messageBody += `<tr><td colspan="5">Total: ${amountOfClients}x</td></tr>`;
              }

              amountOfClients = 0;

              const totalDisplay =
                this.showCurrency === 'dollars'
                  ? `$${groupTotalsByName[row.name].usd.toFixed(2)}`
                  : this.showCurrency === 'soles'
                    ? `S/. ${groupTotalsByName[row.name].pen.toFixed(0)}`
                    : `$${groupTotalsByName[row.name].usd.toFixed(2)} (S/. ${groupTotalsByName[row.name].pen.toFixed(0)})`;

              messageBody += `
                <tr>
                  <td colspan="5" style="background-color:#EAECEE">
                    <div style="display:flex;justify-content:space-between;">
                      <strong>${row.name}</strong>
                      <strong>${totalDisplay}</strong>
                    </div>
                  </td>
                </tr>`;

              group = row.name;
            }

            const price =
              this.showCurrency === 'soles'
                ? row.priceSoles
                : this.showCurrency === 'dollars'
                  ? row.priceUSD
                  : `${row.priceUSD}<br><div style="color:grey;">(${row.priceSoles})</div>`;

            messageBody += `
              <tr>
                <td style="text-indent:10px">${row.full_name}</td>
                <td>${row.duration}</td>
                <td>${row.start}</td>
                <td>${row.end}</td>
                <td style="text-align:right">${price}</td>
              </tr>`;
          }

          messageBody += `<tr><td colspan="5">Total: ${amountOfClients}x</td></tr>`;
        }

        /* ============================================================
          GROUP BY TYPE
        ============================================================ */

        if (this.groupBy === 'type') {

          const groupTotalsByType = {};

          for (const item of result) {
            const usdValue = parseFloat(String(item.priceUSD || 0).replace(/[^0-9.-]/g, '')) || 0;
            const penValue = parseFloat(
              String(item.priceSoles || 0)
                .replace('S/.', '')
                .replace(/,/g, '')
                .trim()
            ) || 0;

            if (!groupTotalsByType[item.type]) {
              groupTotalsByType[item.type] = {
                usd: 0,
                pen: 0,
              };
            }

            groupTotalsByType[item.type].usd += usdValue;
            groupTotalsByType[item.type].pen += penValue;
          }

          messageBody += `
            <colgroup>
              <col style="width:20%">
              <col style="width:30%">
              <col style="width:15%">
              <col style="width:10%">
              <col style="width:10%">
              <col style="width:15%">
            </colgroup>
          `;

          result.sort(this.dynamicSort('type'));

          if (this.servicesClientsList.length === 0) {
            messageBody += this.language === 'english'
              ? `<tr>
                  <th style="text-align:left;text-indent:50px">Service</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>Price</th>
                </tr>`
              : `<tr>
                  <th style="text-align:left;text-indent:50px">Service</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>Precio</th>
                </tr>`;
          } else {
            messageBody += this.language === 'english'
              ? `<tr>
                  <th style="text-indent:10px">Client</th>
                  <th>Service</th>
                  <th>Duration</th>
                  <th>From</th>
                  <th>Until</th>
                  <th>Price</th>
                </tr>`
              : `<tr>
                  <th style="text-indent:10px">Cliente</th>
                  <th>Servicio</th>
                  <th>Duración</th>
                  <th>Desde</th>
                  <th>Hasta</th>
                  <th>Precio</th>
                </tr>`;
          }

          for (let row of result) {

            if (group !== row.type) {

              const totalDisplay =
                this.showCurrency === 'dollars'
                  ? `$${groupTotalsByType[row.type].usd.toFixed(2)}`
                  : this.showCurrency === 'soles'
                    ? `S/. ${groupTotalsByType[row.type].pen.toFixed(0)}`
                    : `$${groupTotalsByType[row.type].usd.toFixed(2)} (S/. ${groupTotalsByType[row.type].pen.toFixed(0)})`;

              messageBody += `
                <tr>
                  <td colspan="6" style="background-color:#EAECEE">
                    <div style="display:flex;justify-content:space-between;">
                      <strong>${row.type}</strong>
                      <strong>${totalDisplay}</strong>
                    </div>
                  </td>
                </tr>`;

              group = row.type;
            }

            const price =
              this.showCurrency === 'soles'
                ? row.priceSoles
                : this.showCurrency === 'dollars'
                  ? row.priceUSD
                  : `${row.priceUSD}<br><div style="color:grey;">(${row.priceSoles})</div>`;

            messageBody += `
              <tr>
                <td style="text-indent:10px">${row.full_name}</td>
                <td>${row.name}</td>
                <td>${row.duration}</td>
                <td>${row.start}</td>
                <td>${row.end}</td>
                <td style="text-align:right">${price}</td>
              </tr>`;
          }
        }

        /* ---------------- TABLE END ---------------- */

        messageBody += `
            </table>
          </div>
          <table style="width:100%">
        `;

        /* ============================================================
          FIXED PRICE
        ============================================================ */

        let showAmountSoles = '';

        if (application.fixedPrice) {

          const priceUSD = this.decUtil.toUSD(application.fixedPrice, application.currencyFixed, this.$store.state.exchangeRate);
          const pricePEN = this.decUtil.toPEN(application.fixedPrice, application.currencyFixed, this.$store.state.exchangeRate);

          if (this.showCurrency === 'dollars') {
            application.currencyFixed = '$';
            application.fixedPrice = priceUSD.toFixed(2);
          }

          if (this.showCurrency === 'soles') {
            application.currencyFixed = 'S/.';
            application.fixedPrice = pricePEN.toFixed(2);
          }

          if (this.showCurrency === 'both') {
            application.fixedPrice = priceUSD.toFixed(2);
            showAmountSoles = `<div style="color:grey;">(S/.${pricePEN.toFixed(0)})</div>`;
          }

          const label =
            this.language === 'english'
              ? 'Corrected Price:'
              : 'Precio Corregido:';

          messageBody += `
            <tr>
              <td style="text-align:right">${label}</td>
              <td style="text-align:right">
                ${application.currencyFixed}${application.fixedPrice}
                ${showAmountSoles}
              </td>
            </tr>
          `;
        }

        /* ============================================================
          DISCOUNT
        ============================================================ */

        if (application.discount) {

          const discountUSD = this.decUtil.toUSD(application.discount, application.currencyDiscount, this.$store.state.exchangeRate);
          const discountPEN = this.decUtil.toPEN(application.discount, application.currencyDiscount, this.$store.state.exchangeRate);

          if (this.showCurrency === 'dollars') {
            application.currencyDiscount = '$';
            application.discount = discountUSD.toFixed(2);
          }

          if (this.showCurrency === 'soles') {
            application.currencyDiscount = 'S/.';
            application.discount = discountPEN.toFixed(2);
          }

          if (this.showCurrency === 'both') {
            application.discount = discountUSD.toFixed(2);
            showAmountSoles = `<div style="color: grey;">(-S/.${discountPEN.toFixed(0)})</div>`;
          }
        }

        if (application.discountPercentage) {

          messageBody += `
            <tr>
              <td style="text-align:right;">
                ${application.discountPercentage}% discount:
              </td>
              <td style="text-align:right;">
                -${application.currencyDiscount}${application.discount}
                ${showAmountSoles}
              </td>
            </tr>
          `;

        } else if (application.discount) {

          const label = this.language === 'english'
            ? 'Discount:'
            : 'Descuento:';

          messageBody += `
            <tr>
              <td style="text-align:right;">${label}</td>
              <td style="text-align:right;">
                -${application.currencyDiscount}${application.discount}
                ${showAmountSoles}
              </td>
            </tr>
          `;
        }

        /* ============================================================
          REFUND
        ============================================================ */

        if (application.refund) {

          const refundUSD = this.decUtil.toUSD(application.refund, application.currencyRefund, this.$store.state.exchangeRate);
          const refundPEN = this.decUtil.toPEN(application.refund, application.currencyRefund, this.$store.state.exchangeRate);

          if (this.showCurrency === 'dollars') {
            application.currencyRefund = '$';
            application.refund = refundUSD.toFixed(2);
          }

          if (this.showCurrency === 'soles') {
            application.currencyRefund = 'S/.';
            application.refund = refundPEN.toFixed(2);
          }

          if (this.showCurrency === 'both') {
            application.refund = refundUSD.toFixed(2);
            showAmountSoles = `<div style="color: grey;">(-S/.${refundPEN.toFixed(0)})</div>`;
          }

          const label = this.language === 'english'
            ? 'Refund:'
            : 'Reembolso:';

          messageBody += `
            <tr>
              <td style="text-align:right;">${label}</td>
              <td style="text-align:right;">
                -${application.currencyRefund}${application.refund}
                ${showAmountSoles}
              </td>
            </tr>
          `;
        }

        /* ============================================================
          TOTAL PRICE
        ============================================================ */

        const totalPriceText =
          this.language === 'english'
            ? 'Total Price:'
            : 'Precio Total:';

        if (this.showCurrency === 'both') {

          messageBody += `
            <tr>
              <td></td>
              <td style="text-align:right;">
                <div>
                  <span style="margin-right:1cm;">${totalPriceText}</span>
                  <span style="padding-left:1cm;font-size:24px;color:#35b729;border-top:1px solid black;">
                    ${Number(application.totalPrice).toFixed(2)} USD
                  </span>
                  <div style="color:grey;">
                    (${Number(application.totalPrice * application.exchangeRate).toFixed(0)} PEN)
                  </div>
                </div>
              </td>
            </tr>
          `;

        }

        if (this.showCurrency === 'dollars') {

          messageBody += `
            <tr>
              <td></td>
              <td style="text-align:right;">
                <div>
                  <span style="margin-right:1cm;">${totalPriceText}</span>
                  <span style="padding-left:1cm;font-size:24px;color:#35b729;border-top:1px solid black;">
                    ${Number(application.totalPrice).toFixed(2)} USD
                  </span>
                </div>
              </td>
            </tr>
          `;

        }

        if (this.showCurrency === 'soles') {

          messageBody += `
            <tr>
              <td></td>
              <td style="text-align:right;">
                <div>
                  <span style="margin-right:1cm;">${totalPriceText}</span>
                  <span style="padding-left:1cm;font-size:24px;color:#35b729;border-top:1px solid black;">
                    ${Number(application.totalPrice * application.exchangeRate).toFixed(0)} PEN
                  </span>
                </div>
              </td>
            </tr>
          `;

        }

        messageBody += `
          </table>
          <div style="margin-bottom:1cm;"></div>
        `;

        /* ============================================================
          FOOTNOTES
        ============================================================ */

        if (this.updatedApplication.donationValueOnInvoice) {

          const text = this.language === 'english'
            ? `The total includes a donation of $${this.updatedApplication.donationValueOnInvoice} which goes directly to the projects where you work.`
            : `Este total incluye una donación de $${this.updatedApplication.donationValueOnInvoice} que va directamente a los proyectos donde trabajas.`;

          messageBody += `<div style="font-size:12px;">${text}</div>`;
        }

        if (this.includesPickup) {

          const text = this.language === 'english'
            ? 'This offer includes a pick-up service from Cusco airport or bus terminal.'
            : 'Esta oferta incluye un servicio de recogida desde el aeropuerto de Cusco o la terminal de buses.';

          messageBody += `<div style="font-size:12px;">${text}</div>`;
        }

        if (this.includesSocialActivities) {

          const text = this.language === 'english'
            ? 'Also includes 24 hours in-country support and free social activities.'
            : 'Incluye también soporte en el país las 24 horas y actividades sociales gratuitas.';

          messageBody += `<div style="font-size:12px;">${text}</div>`;
        }

        let totalPaidUSD = 0;
        if ((applicationIncome.length > 0 || applicationOutgoing.length > 0) && this.showCurrentBalance) {
            messageBody +=  "<div style='margin-top: 0.5cm;'>" 
            messageBody += "<table style='width: 100%;'>";
            let paymentOnText = "";
            if (this.language === 'english') {
              paymentOnText = "Payment on ";
            } else {
              paymentOnText = "Pago el ";
            }
            console.log('createInvoice #2', applicationIncome);

            for (let index = 0; index < applicationIncome.length; index++) {

              const income = applicationIncome[index];

              const incomeUSD = this.decUtil.toDec(income.amount);
              
              totalPaidUSD = this.decUtil.toDec(totalPaidUSD)
                .plus(incomeUSD)
                .toNumber();

              const paidDate = this.formattedDate(income.paidOn, "Noday");

              // ----------------------------
              // BOTH CURRENCIES
              // ----------------------------
              if (this.showCurrency === 'both') {

                const usdAmount = incomeUSD.toFixed(2);
                const penAmount = incomeUSD
                  .times(application.exchangeRate)
                  .toFixed(0);

                messageBody += `
                  <tr>
                    <td style="text-align:right;">
                      <span>${paymentOnText}${paidDate}:</span>
                    </td>
                    <td style="text-align:right; font-size:16px; padding-left:1cm;">
                      - $${usdAmount}
                      <div style="color: grey;">(- S/.${penAmount})</div>
                    </td>
                  </tr>
                `;

              } 
              // ----------------------------
              // SINGLE CURRENCY
              // ----------------------------
              else {

                let currencyPayment = '';
                let amountPayment = '';

                if (this.showCurrency === 'dollars') {
                  currencyPayment = '$';
                  amountPayment = incomeUSD.toFixed(2);
                }

                if (this.showCurrency === 'soles') {
                  currencyPayment = 'S/.';
                  amountPayment = incomeUSD
                    .times(application.exchangeRate)
                    .toFixed(0);
                }

                messageBody += `
                  <tr>
                    <td style="text-align:right;">
                      <span>${paymentOnText}${paidDate}:</span>
                    </td>
                    <td style="text-align:right; font-size:16px; padding-left:1cm;">
                      - ${currencyPayment}${amountPayment}
                    </td>
                  </tr>
                `;
              }

            }

            let paidBackOnText = "";
            if (this.language === 'english') {
              paidBackOnText = "Paid back on ";
            } else {
              paidBackOnText = "Pagado el ";
            }

            console.log('createInvoice #3', applicationOutgoing);

            for (let index = 0; index < applicationOutgoing.length; index++) {

              const outgoing = applicationOutgoing[index];

              // Normalize outgoing to USD
              const outgoingUSD = outgoing.currency === '$'
                ? this.decUtil.toDec(outgoing.amount)
                : this.decUtil.toDec(outgoing.amount).div(application.exchangeRate);

              // Add to totalPaidUSD
              totalPaidUSD = this.decUtil.toDec(totalPaidUSD)
                .plus(outgoingUSD)
                .toNumber();

              const paidDate = this.formattedDate(outgoing.dateTime, "Noday");

              // ----------------------------
              // BOTH CURRENCIES
              // ----------------------------
              if (this.showCurrency === 'both') {

                const usdAmount = outgoingUSD.toFixed(2);
                const penAmount = outgoingUSD
                  .times(application.exchangeRate)
                  .toFixed(0);

                messageBody += `
                  <tr>
                    <td style="text-align:right;">
                      <span>${paidBackOnText}${paidDate}:</span>
                    </td>
                    <td style="text-align:right; font-size:16px; padding-left:1cm;">
                      - $${usdAmount}
                      <div style="color: grey;">(- S/.${penAmount})</div>
                    </td>
                  </tr>
                `;

              } 
              // ----------------------------
              // SINGLE CURRENCY
              // ----------------------------
              else {

                let currencyPayback = '';
                let amountPayback = '';

                if (this.showCurrency === 'dollars') {
                  currencyPayback = '$';
                  amountPayback = outgoingUSD.toFixed(2);
                }

                if (this.showCurrency === 'soles') {
                  currencyPayback = 'S/.';
                  amountPayback = outgoingUSD
                    .times(application.exchangeRate)
                    .toFixed(0);
                }

                messageBody += `
                  <tr>
                    <td style="text-align:right;">
                      <span>${paidBackOnText}${paidDate}:</span>
                    </td>
                    <td style="text-align:right; font-size:16px; padding-left:1cm;">
                      - ${currencyPayback}${amountPayback}
                    </td>
                  </tr>
                `;

              }

            }

            messageBody += "</table><br>";

            const currentBalance = this.decUtil.toDec(application.totalPrice)
              .minus(totalPaidUSD);

            const currentBalanceText =
              this.language === 'english'
                ? 'Current Balance: '
                : 'Saldo Actual: ';

            messageBody += `<div style="text-align: right;">`;

            if (this.showCurrency === 'both' || this.showCurrency === 'dollars') {

              const usdAmount = currentBalance.toFixed(2);
              const penAmount = currentBalance
                .times(application.exchangeRate)
                .toFixed(0);

              messageBody += `
                <span style="margin-right: 1cm">${currentBalanceText}</span>
                <span style="font-size: 24px; color: #35b729; border-top: 1px solid black; padding-left: 1cm;">
                  ${usdAmount} USD
                </span>
              `;

              if (this.showCurrency === 'both') {
                messageBody += `
                  <div style="color: grey;">(${penAmount} PEN)</div>
                `;
              }

            } else {

              const penAmount = currentBalance
                .times(application.exchangeRate)
                .toFixed(0);

              messageBody += `
                <span style="margin-right: 1cm">${currentBalanceText}</span>
                <span style="font-size: 24px; color: #35b729; border-top: 1px solid black; padding-left: 1cm;">
                  ${penAmount} PEN
                </span>
              `;

            }

            messageBody += `</div>`;

        }
        
        if (this.addDeposit) {

          const depositUSD = this.decUtil.toDec(application.depositTotal);
          const depositPEN = depositUSD.times(this.decUtil.toDec(application.exchangeRate));

          const usdText = `$${depositUSD.toFixed(0)}`;
          const penText = `S/.${depositPEN.toFixed(0)}`;

          const introText =
            this.language === 'english'
              ? 'While we prefer payment in full at time of booking, you can reserve your experience by paying a deposit of '
              : 'El depósito mínimo es de ';

          const outroText =
            this.language === 'english'
              ? ' with the balance due 30 days before the first day of your program. Please note that the deposit policy does not apply to Online Classes or Excursions/Tours, which must be paid in full at time of booking. Please read our ' + 
              '<a target="_blank" href="https://proyectoperucentre.org/terms-conditions/">' +
                ' Terms & Conditions ' +
              '</a>' + 
              ' for more information regarding deposits.'
              : ' para comenzar con todas las preparaciones necesarias. El depósito es su confirmación y reserva formal. El resto lo puedes pagar en el primer día, una vez que tus servicios comienzan.';

          let amountText = '';

          if (this.showCurrency === 'both') {
            amountText = `${usdText} (${depositPEN.toFixed(0)} PEN)`;
          } else if (this.showCurrency === 'dollars') {
            amountText = usdText;
          } else {
            amountText = penText;
          }

          messageBody += `
            <div style="margin-top:1cm;">
              <div>
                ${introText}${amountText}${outroText}
              </div>
            </div>
          `;
        }

        /* ============================================================
          COMMENTS
        ============================================================ */

        if (application.comments) {
          messageBody += `
            <div style="margin-top:2cm;">
              <div>${application.comments}</div>
            </div><br/>
          `;
        }

        /* ============================================================
          FOOTER HEADER
        ============================================================ */

        let messageFooter = '';

        messageFooter += `
          <div style="text-align:center;margin-top:30px;font-size:14px;">
            ${this.language === 'english'
              ? '- this invoice is valid for 15 days - '
              : '- este recibo es valida por 15 días -'}
          </div>
        `;

        messageFooter += `
          <div style="text-align:center;font-size:14px;">
            ${this.paymentRecommendation
              ? 'Note: we recommend making payment as early as possible as project, class and excursion availability can change at short notice'
              : ''}
          </div><br><br>
        `;

        /* ============================================================
          CALCULATED TOTAL BALANCE
        ============================================================ */

        const remainingUSD = this
          .decUtil.toDec(application.totalPrice)
          .minus(this.decUtil.toDec(totalPaidUSD));

        /* ============================================================
          EXCHANGE RATES
        ============================================================ */

        const rates = this.$store.state.exchangeRates?.rates || {};

        console.log('rates: ', rates);

        let rateEUR = this.decUtil.toDec(rates.EUR || 0);
        let rateGBP = this.decUtil.toDec(rates.GBP || 0);

        if (!Object.keys(rates).length) {
          this.noRates = true;
        }

          messageFooter += `
            <h2>${this.language === 'english'
              ? 'Payment Methods:'
              : 'Métodos de pago:'}</h2><br>
          `;

          /* ========================================================
            WISE
          ======================================================== */

          if (this.showWisePayment) {

            const remainingEUR = remainingUSD.times(rateEUR);
            const remainingGBP = remainingUSD.times(rateGBP);

            messageFooter += `
              <h3>Pay with Wise paying minimal bank transfer fees (from zero)</h3>
              <a target="_blank" href="https://wise.com/pay/business/proyectoperucentresac">
                Pay with wise.com
              </a><br><br>

              <div style="font-size:12px">

              <strong>Bank Information for sending USD from an account inside the USA:</strong><br>
              Account holder: Proyecto Peru Centre S.A.C. -
              Routing number: 026073150 -
              Account number: 8312474700<br>
              Account type: Checking<br>
              Bank name: Community Federal Savings Bank -
              Address: 89-16 Jamaica Ave, Woodhaven NY 11421, United States<br>
            `;

            if (!this.noRates) {
              messageFooter += `Amount: <strong>${remainingUSD.toFixed(2)} USD</strong>`
            }

            if (
              this.addDeposit &&
              application.pass_to_planning === 0 &&
              application.depositTotal > 0 &&
              remainingUSD.greaterThan(25)
            ) {
              messageFooter += `
                <br>Deposit: <strong>${this.decUtil.toDec(application.depositTotal).toFixed(2)} USD</strong>
              `;
            }

            messageFooter += `
              <br><br>

              <strong>Bank Information for sending USD from an account outside the USA:</strong><br>
              Account holder: Proyecto Peru Centre S.A.C. -
              Routing number: 026073150 -
              SWIFT/BIC: CMFGUS33 -
              Account number: 8312474700<br>
              Bank name: Community Federal Savings Bank -
              Address: 89-16 Jamaica Ave, Woodhaven NY 11421, United States<br>
            `;
            
            if (!this.noRates) {
              messageFooter += `Amount: <strong>${remainingUSD.toFixed(2)} USD</strong>`
            }

            messageFooter += `
              <br><br>

              <strong>Bank Information for sending Euros:</strong><br>
              Account holder: Proyecto Peru Centre S.A.C. -
              SWIFT/BIC: TRWIBEB1XXX -
              IBAN: BE41 9674 5027 8410<br>
              Bank name: Wise -
              Address: Rue du Trône 100, 3rd floor, Brussels, 1050, Belgium<br>
            `;

            if (!this.noRates) {
              messageFooter += `Amount: <strong>${remainingEUR.toFixed(2)} EUR</strong>`
            }

            messageFooter += `
              <br><br>

              <strong>Bank Information for sending British Pounds from an account inside the UK:</strong><br>
              Account holder: Proyecto Peru Centre S.A.C. -
              Sort code: 23-14-70 -
              Account number: 64598776<br>
              IBAN: GB34 TRWI 2314 7064 5987 76<br>
              Bank name: Wise Payments Limited -
              Address: 56 Shoreditch High Street, London, E1 6JJ, United Kingdom<br>
            `;

            if (!this.noRates) {
              messageFooter += `Amount: <strong>${remainingGBP.toFixed(2)} GBP</strong>`
            }

            messageFooter += `
              <br><br>

              If you have a different currency, ask us if we have its account info to avoid exchange rate costs.
              </div><br><br>
            `;
          }

          /* ========================================================
            NUBIZ
          ======================================================== */

          if (this.showCreditCardPayment) {
            messageFooter += `
              <h3>${this.language === 'english'
                ? 'Pay with Credit Card (add 5% bank transfer fees)'
                : 'Paga con Tarjeta de Crédito (aumenta 5% del costos bancarios)'}</h3>

              <a target="_blank"
                href="https://express.culqi.com/pago/D85356BC88">
                ${this.language === 'english' ? 'Pay here' : 'Paga aquí'}
              </a><br><br><br>
            `;
          }

          /* ========================================================
            SOLES TRANSFER
          ======================================================== */

          if (this.showSolesPayment) {
            messageFooter += `
              <h3>${this.language === 'english'
                ? 'Deposit to Proyecto Peru Centre S.A.C. in Soles'
                : 'Depósito a nombre de Proyecto Peru Centre S.A.C. en Soles'}</h3>

              Account BCP (soles): 2852239009038<br>
              Account interbanks: 00228500223900903853<br>
            `;
          }

          messageFooter += `
            <div style="margin-top:10px;margin-bottom:2cm;background:#c7d3d1;height:2px;"></div>
          `;

        /* ============================================================
          LINKS
        ============================================================ */

        messageFooter += `
          <a target="_blank" href="https://proyectoperucentre.org/payment-methods/">
            More on Payment Methods
          </a>
          <span style="margin:0 10px;">-</span>
          <a target="_blank" href="https://proyectoperucentre.org/terms-conditions/">
            Terms & Conditions
          </a><br><br>
        `;

        this.messageHTML = messageHeader + messageBody + messageFooter;


        
        this.$store.dispatch('setLoadingApp', 0);
        this.dialogInvoice = true;
        payload = {
            submittedFrom: "Invoice",
            emailList: this.payer.email,
            emailSubject: `Invoice Proyecto Peru`,
            emailIntro: emailIntro,
            messageHTML: "<div style='margin: 1cm 0 1cm 0; background-color: #c7d3d1; text-align: left; width: 100%; height: 2px;'></div>" + this.messageHTML,
            messagePlain: '',
            openEmailDialog: false,
            saveInvoice: true,
        };
        this.$store.dispatch('emailMessage', payload);
        // check if invoice exists
        if (this.$route.name === 'Client' || this.$route.name === 'Application') {
          for (let i = 0; i < this.invoicesOnApplication.length; i++) {
            let archiveInvoice = JSON.parse(zlib.unzipSync(Buffer.from(this.invoicesOnApplication[i].contentZip, 'base64')));
            let pos = archiveInvoice.indexOf('refnr');
            archiveInvoice = archiveInvoice.slice(pos);
            pos = archiveInvoice.indexOf('Payment Methods');
            archiveInvoice = archiveInvoice.slice(0, pos);
            let compare = JSON.stringify(this.messageHTML);
            pos = compare.indexOf('refnr');
            compare = compare.slice(pos);
            pos = compare.indexOf('Payment Methods');
            compare = compare.slice(0, pos);
            if (archiveInvoice === compare) {
              this.archiveInvoice = true;
            }
          }
        }
      },

      async getUser(application) {
        console.log('getUser', application);
        if (application.payerAgency) {
          this.dataSaveInvoice.payerAgency = application.payerAgency;
          this.payer = this.$store.state.available_agencies.filter(function(item) {
              return item.id === application.payerAgency;
          })[0];
          this.dataSaveInvoice.payerName = this.payer.name;
          let country_id = this.payer.country_id;
          if (country_id) {
            this.payer.nationality = this.$store.state.itemsNationality.filter(function(item) {
                return item.id === country_id;
            })[0].nationality;
          } else {
            this.payer.nationality = '';
          }
        } else if (application.payerClient) {
          this.dataSaveInvoice.payerClient = application.payerClient;
          this.payer = await this.$store.dispatch('getClientId', application.payerClient);
          this.payer.name = this.payer.first_name + " " + this.payer.last_name;
          this.dataSaveInvoice.payerName = this.payer.name;
        }
      },

      getIntro(name) {
        return `Dear ${name},


        Thank you for having interest in our services!

        Below you'll find your invoice. You can find our payment methods on https://proyectoperucentre.org/payment-methods/
        Please let us know if you want to change your program or if you need any help.


        Kind regards,

        ${this.$store.state.user}

        info@proyectoperucentre.org
        Proyecto Peru Centre
        Avenida Arcopata 466-A
        Cusco, Cusco, 45
        +51 950 301 314`;
      },
      
      getRefnr() {
          let refnr = this.applicationId.toString()
          return refnr.substr(1,refnr.length-1)
      },
      
      async insertInvoice () {
        const zip = zlib.gzipSync(JSON.stringify(this.messageHTML)).toString('base64');
        this.dataSaveInvoice.contentZip = zip;
        let response = await this.$store.dispatch('insertInvoice', this.dataSaveInvoice);
        if (response === 200) {
          this.$store.dispatch('successMessage', 'Invoice saved succesfully');
          this.archiveInvoice = true;
        } else {
          this.$store.dispatch('errorMessage', 'Invoice not saved correctly');
        }
        if (this.dialogApplication) {
          this.invoicesOnApplication = await this.$store.dispatch('getInvoices', this.updatedApplication.id);
        }
      },

      async displayInvoice(application) {
        console.log("displayInvoice", application);
        this.$store.dispatch('setLoadingApp', 1);
        if (application) {
          this.archiveInvoice = true;
        } else {
          application = JSON.parse(JSON.stringify(this.$store.state.dataForReport));
          this.$store.dispatch('saveDataForReport', );
          this.archiveInvoice = application.archive;
        }
        console.log("displayInvoice #1", this.archiveInvoice);
        if (this.archiveInvoice) {
          this.messageHTML = JSON.parse(zlib.unzipSync(Buffer.from(application.contentZip, 'base64')));
          await this.getUser(application);
          let emailIntro = await this.getIntro(this.payer.name);
          let payload = {
              submittedFrom: "AccommodationPaymentForm",
              emailList: this.payer.email,
              emailSubject: "Pago Accommodacíon Proyecto Peru",
              emailIntro: emailIntro,
              messageHTML: this.messageHTML,
          };
          await this.$store.dispatch('emailMessage', payload);
          this.dialogInvoice = true;
        } else {
          this.applicationId = application.id;
          console.log(this.applicationId);
          this.createInvoice();
        }
        this.$store.dispatch('showInvoice', false);
        this.$store.dispatch('setLoadingApp', 0);
      },
      
      showInvoiceControlPanel() {
        if (this.$route.name === 'Invoices') {
          return false;
        } else {
          // console.log('showInvoiceControlPanel', this.$route.name);
          return true;
        }
      },

      async displayApplication() {
        console.log('displayApplication');
        this.appWithOnlyEnglish = true;
        let application = JSON.parse(JSON.stringify(this.$store.state.dataForReport));
        console.log('displayApplication #1', application);
        this.$store.dispatch('saveDataForReport', );
        this.loadingApplicationDialog = true;
        this.$store.dispatch('setLoadingApp', 1);
        this.extraChargeToRemove = [];
        this.extraCharge = [];
        this.updatedApplication = JSON.parse(JSON.stringify(application));
        this.servicesClientsList = [];
        var date = new Date();
        let start = date.getTime();
        console.log('***1 displayApplication');
        this.updatedApplication.invoice_date = this.formattedDate(this.$store.state.today, 'date');
        await Promise.all([
          this.applicationIncome = await this.$store.dispatch('getDistributionsApplicationId', application.id), 
          this.outgoingsApp = await this.$store.dispatch('getOutgoingsApp', application.id), 
          this.invoicesOnApplication = await this.$store.dispatch('getInvoices', application.id), 
          this.servicesInApp = await this.$store.dispatch('getServicesAppId', application.id),
          this.extraCharge = await this.$store.dispatch('getExtraChargesAppId', application.id)]).then( async() => {
            if (this.extraCharge.length === 0) {
              this.extraCharge = [];
            } else {
              for (let index = 0; index < this.extraCharge.length; index++) {
                if (this.extraCharge[index].currency === 'S/.') {
                  this.extraCharge[index].amount = this.decUtil.format(this.decUtil.toDec(this.extraCharge[index].amount),0);
                } else {
                  this.extraCharge[index].amount = this.decUtil.format(this.decUtil.toDec(this.extraCharge[index].amount));
                }
                
              }
            }
            this.checkExtraChargeNew();
            this.calcTotalPrice();

            date = new Date();
            let end = date.getTime();
            let totalTime = ((end-start)/1000);
            console.log('***2', totalTime, this.applicationIncome);

            this.applicationTransfers = JSON.parse(JSON.stringify(this.applicationIncome));
            for (let index = 0; index < this.outgoingsApp.length; index++) {
              this.outgoingsApp[index].amount = -1 * this.outgoingsApp[index].amount;
              // this.outgoingsApp[index].amountIncome = this.outgoingsApp[index].amount;  RAAR!
              if (this.outgoingsApp[index].currency === 'S/.') {
                this.outgoingsApp[index].amount = -1 * this.outgoingsApp[index].amountDollars;
              }
              this.outgoingsApp[index].currencyIncome = this.outgoingsApp[index].currency;
              this.outgoingsApp[index].paidOn = this.formattedDate(this.outgoingsApp[index].dateTime, 'date');
              this.applicationTransfers.push(this.outgoingsApp[index]);
            }

            this.updatedApplication.amountPaidApplication = this.applicationTransfers
              .reduce(
                (sum, t) => sum.plus(this.decUtil.toDec(t.amount)),
                this.decUtil.toDec(0)
              )
              .toFixed(2);

            // get application + services
            if (this.updatedApplication.amountOfClients === 1) {
                this.groupBy = "type";
            } else {
                this.groupBy = "full_name";
            }

            date = new Date();
            end = date.getTime();
            totalTime = ((end-start)/1000);
            console.log('***3', totalTime);

            var client = {};
            let active = false;
            for (let index = 0; index < this.servicesInApp.length; index++) {
                if (this.servicesInApp[index].client_id === this.updatedApplication.clientId) {
                    active = true;
                  } else {
                    active = false;
                  }
                client = {
                    id: this.servicesInApp[index].client_id,
                    name: this.servicesInApp[index].full_name,
                    statusServiceId: this.servicesInApp[index].statusServiceId,
                    active: active,
                };
                let objIndex = this.servicesClientsList.findIndex(item => item.id === client.id);
                if (objIndex === -1) {
                    this.servicesClientsList.push(client);
                } else {
                    if (client.statusServiceId === 4) {
                        this.servicesClientsList[objIndex].statusServiceId = 4;
                    }
                }
                if (this.servicesInApp[index].type_id !== 8) {
                    this.appWithOnlyEnglish = false;
                }
            }
            for (let index = 0; index < this.servicesClientsList.length; index++) {
                let services = [];
                let clientId = this.servicesClientsList[index].id;
                let allServices = this.servicesInApp.filter(function(item) {
                    return item.client_id ===  clientId;
                })
                for (let index2 = 0; index2 < allServices.length; index2++) {
                  let service = {
                    id: allServices[index2].id,
                    name: allServices[index2].name,
                    price: allServices[index2].servicePrice,
                    currency: allServices[index2].currency,
                  }
                  services.push(service);
                }
                this.servicesClientsList[index].services = services;
            }
            this.servicesClientsList.sort(this.dynamicSort('name'));
            console.log('displayApplication #3', this.applicationIncome);
            if (this.servicesInApp.length === 0) {
                this.appWithOnlyEnglish = false;
            }
            this.$store.dispatch('setLoadingApp', 0);
            this.loadingApplicationDialog = false;

            // console.log("totalPrice", this.updatedApplication.totalPrice)
            // console.log("amountPaidApplication", this.updatedApplication.amountPaidApplication)
            // console.log("openAmount", this.getOpenAmount(this.updatedApplication))

            this.dialogApplication = true;

            date = new Date();
            end = date.getTime();
            totalTime = ((end-start)/1000);
            console.log('***4', totalTime);
        });
      },

      checkExtraChargeNew() {
        if (!this.extraCharge[0] || 
        (this.extraCharge[this.extraCharge.length - 1].title !== null && 
        this.extraCharge[this.extraCharge.length - 1].title !== '') || 
        this.extraCharge[this.extraCharge.length - 1].amount !== 0) {
          let payload = {
            id: null,
            title: '',
            amount: 0,
            currency: '$',
          }
          this.extraCharge.push(payload);
          // this.newExtraCharge = null;
        }
        console.log('checkExtraChargeNew #2', this.extraCharge);
      },

      removeExtraCharge(index) {
        if (this.extraCharge.id !== null) {
          this.extraChargeToRemove.push(this.extraCharge[index].id);
        }
        this.extraCharge.splice(index, 1);
        this.calcTotalPrice();
        console.log('removeExtraCharge', this.extraCharge, this.extraChargeToRemove);
      },

      calcSumExtraChargesUSD() {

        let sumExtraChargesUSD = this.decUtil.toDec(0);
        const exchangeRate = this.decUtil.toDec(this.$store.state.exchangeRate || 1);

        if (this.extraCharge && this.extraCharge.length > 0) {

          for (const charge of this.extraCharge) {

            if (!charge.amount) continue;

            const amount = this.decUtil.toDec(charge.amount);

            const normalized =
              charge.currency === "S/."
                ? amount.div(exchangeRate)
                : amount;

            sumExtraChargesUSD = sumExtraChargesUSD.plus(normalized);
          }
        }

        return this.decUtil.format(sumExtraChargesUSD);
      },

      calcSumExtraChargesPEN() {
        return this.decUtil.format(this.decUtil.toDec(this.calcSumExtraChargesUSD()).mul(this.decUtil.toDec(this.$store.state.exchangeRate || 1)),0);
      },

      calcOtherCurrency(amount, currency, exchangeRate) {

        if (amount === null || amount === undefined) {
          return "-";
        }

        const amt = this.decUtil.toDec(amount);
        const rate = this.decUtil.toDec(exchangeRate || 1);

        if (currency === "S/.") {
          // Convert to USD
          return "$" + this.decUtil.format(amt.div(rate));
        }

        // Convert to Soles
        return "S/." + this.decUtil.format(amt.mul(rate),0);
      },

      

      // distributionsTotal () {
      //     var distributionsTotal = 0;
      //     if (this.applicationIncome.length > 0) {
      //         for (let index = 0; index < this.applicationIncome.length; index++) {
      //             distributionsTotal = distributionsTotal + this.applicationIncome[index].amount;
      //         }
      //     }
      //     return distributionsTotal;
      // },

      async calcTotalPrice() {

        console.log("calcTotalPrice");

        let totalPrice = this.decUtil.toDec(0);
        const rate = this.decUtil.toDec(this.updatedApplication.exchangeRate || 1);

        // ---------- NORMALIZE INPUTS ----------
        if (this.updatedApplication.fixedPrice !== null) {
          this.updatedApplication.fixedPrice =
            this.decUtil.toDec(this.updatedApplication.fixedPrice).toFixed(2);
        }

        if (this.updatedApplication.refund !== null) {
          this.updatedApplication.refund =
            this.decUtil.toDec(this.updatedApplication.refund).toFixed(2);
        }

        if (this.updatedApplication.discount !== null) {
          this.updatedApplication.discount =
            this.decUtil.toDec(this.updatedApplication.discount).toFixed(2);
        }

        if (this.updatedApplication.discountPercentage !== null) {
          this.updatedApplication.discountPercentage =
            this.decUtil.toDec(this.updatedApplication.discountPercentage).toNearest(1).toString();
        }

        // ---------- BASE PRICE ----------
        if (this.updatedApplication.fixedPrice === null) {

          totalPrice = this.decUtil.toDec(this.calcSumServicesPrice);

        } else if (this.updatedApplication.currencyFixed === "$") {

          totalPrice = this.decUtil.toDec(this.updatedApplication.fixedPrice);

        } else {

          totalPrice = this.decUtil.toDec(this.updatedApplication.fixedPrice).div(rate);
        }

        // ---------- REFUND ----------
        if (this.updatedApplication.refund !== null) {

          const refund =
            this.updatedApplication.currencyRefund === "$"
              ? this.decUtil.toDec(this.updatedApplication.refund)
              : this.decUtil.toDec(this.updatedApplication.refund).div(rate);

          totalPrice = totalPrice.minus(refund);
        }

        // ---------- DISCOUNT ----------
        if (
          this.updatedApplication.discountPercentage &&
          this.decUtil.toDec(this.updatedApplication.discountPercentage).gt(0)
        ) {

          const discount = totalPrice
            .mul(this.decUtil.toDec(this.updatedApplication.discountPercentage))
            .div(100);

          this.updatedApplication.discount = discount.toFixed(2);
          totalPrice = totalPrice.minus(discount);

        } else if (
          this.updatedApplication.discount &&
          this.decUtil.toDec(this.updatedApplication.discount).gt(0)
        ) {

          const discount =
            this.updatedApplication.currencyDiscount === "$"
              ? this.decUtil.toDec(this.updatedApplication.discount)
              : this.decUtil.toDec(this.updatedApplication.discount).div(rate);

          totalPrice = totalPrice.minus(discount);
        }

        // ---------- EXTRA CHARGES ----------
        totalPrice = totalPrice.plus(
          this.decUtil.toDec(this.calcSumExtraChargesUSD())
        );

        // ---------- FINAL ----------
        this.updatedApplication.totalPrice = totalPrice.toFixed(2);
      },

      updatePayer (payer, event) {
          console.log('updatePayer', payer, event, this.updatedApplication, this.servicesClientsList);
          if (payer === 'Client') {
              this.updatedApplication.payerClient = event;
              this.updatedApplication.payerAgency = null;
              this.updatedApplication.transferFeeIncluded = false;
          } else {
              this.updatedApplication.payerClient = null;
              this.updatedApplication.payerAgency = event;
              if (event) {
                  let tmp = this.$store.state.available_agencies.filter(function(select_item) {
                      return select_item.id === event;
                  });
                  this.updatedApplication.transferFeeIncluded = tmp[0].transferFeeIncluded;
              } else {
                  this.updatedApplication.transferFeeIncluded = false;
              }
          }
      },

      async saveApplication (application, closeDialogApplication) {
        // console.log("saveApplication", application, this.extraCharge);

        if (!this.updatedApplication.payerClient && !this.updatedApplication.payerAgency) {
            this.$store.dispatch('warningMessage', 'No payer assigned!');
            return;
        }

        this.$store.dispatch('setLoadingApp', 1);

        for (let index = 0; index < this.extraCharge.length - 1; index++) {
          let payload = {
            id: this.extraCharge[index].id,
            application_id: application.id,
            title: this.extraCharge[index].title,
            amount: this.extraCharge[index].amount,
            currency: this.extraCharge[index].currency
          }
          let insertId = await this.$store.dispatch('insertExtraCharges', payload);
          if (insertId && payload.id === null) {
            this.extraCharge[index].id = insertId;
          }
        }
        for (let index = 0; index < this.extraChargeToRemove.length; index++) {
          this.$store.dispatch('removeExtraCharge', this.extraChargeToRemove[index]);
        }
        let payload = {
          client: null,
          applications: [],
          services: null,
          radioGroups: null,
          radioOptions: null,
          options: null,
          resources: null,
        };
        payload.applications.push(application);
        await this.$store.dispatch('insertUpdateMainItems', payload);
        // console.log('saveApplication #4.1', result);
        
        this.$store.dispatch('loadApplications', true);
        if (closeDialogApplication) {
          this.dialogApplication = false
        }
        this.$store.dispatch('setLoadingApp', 0);
      },

      async changeAppTitle (application) {
        console.log('changeAppTitle', application);
        if (application.autoAppTitle) {
          this.updatedApplication.appTitle = await this.createAppTitle(application, null);
        }
      },

      async addPayment(appId, currency) {
        this.dialogApplication = false;
        this.$store.dispatch('setLoadingApp', 1)
        await this.saveApplication(this.updatedApplication, false);
        let incomeType = 2;
        if (this.appWithOnlyEnglish) {
            if (this.updatedApplication.payerClient !== null) {
                incomeType = 9;
            } else {
                incomeType = 19;
            }
        } else {
            if (this.updatedApplication.payerClient !== null) {
                incomeType = 2;
            } else {
                incomeType = 16;
            }
        }
        this.$store.dispatch('setLoadingApp', 1)
        this.$router.push({ name: 'Financial', params: { appId: appId, currency: currency, incomeType: incomeType, clientId: null } })
      },

      async addRefund(appId, currency) {
        this.dialogApplication = false;
        this.$store.dispatch('setLoadingApp', 1)
        await this.saveApplication(this.updatedApplication, false);
        this.$router.push({ name: 'Financial', params: { refund: true, appId: appId, currency: currency, outgoingType: 78 } })  
      },

      async goFinancial(item) {
          console.log(item);
          this.dialogApplication = false;
          this.$store.dispatch('setLoadingApp', 1)
          await this.saveApplication(this.updatedApplication, false);
          if (item.income_id) {
              console.log('transaction');
              this.$router.push({ name: 'Financial', params: { income_id: item.income_id, paidOn: item.paidOn } })
          } else {
              console.log('outgoing');
              this.$router.push({ name: 'Financial', params: { outgoing_id: item.id, paidOn: item.paidOn } })
          }
      },

      async doClasses() {
        console.log('doClasses');
        this.$store.dispatch('setLoadingApp', 1);

        var date = new Date();
        let start = date.getTime();
        console.log('doClasses @@@1');

        let result = await this.$store.dispatch('checkAllClasses');

        console.log('doClasses result: ', result);

        date = new Date();
        let end = date.getTime();
        const totalTime = ((end-start)/1000);
        console.log('doClasses @@@2', totalTime);

        console.log('doClasses Finished');

        this.$store.dispatch('setLoadingApp', 0);
      },

      async doClassGroups() {
        console.log('doClassGroups');
        this.$store.dispatch('setLoadingApp', 1);

        let classGroups = JSON.parse(JSON.stringify(await this.$store.dispatch('getClassGroupsSafe', 'closed = 0 OR closed = 1')));

        var date = new Date();
        let start = date.getTime();
        console.log('doClassGroups @@@1');

        let teller = 0;
        if (classGroups) {
          console.log('doClassGroups', classGroups.length);
          for (let index = 0; index < classGroups.length; index++) {

            classGroups[index].last_change = this.formattedDate(Date.parse(date), 'dateTime');
            await this.$store.dispatch('insertClassGroup', classGroups[index]);

            if (Math.round(index/classGroups.length*100) > teller) {
              console.log('doClassGroups', Math.round(index/classGroups.length*100) + '%');
              teller = teller + 1;
            }

          }
        }

        date = new Date();
        let end = date.getTime();
        const totalTime = ((end-start)/1000);
        console.log('doClassGroups @@@2', totalTime);

        console.log('doClassGroups Finished');

        this.$store.dispatch('setLoadingApp', 0);
      },

      async doIncome() {
        console.log('doIncome');
        this.$store.dispatch('setLoadingApp', 1);

        let incomes = JSON.parse(JSON.stringify(await this.$store.dispatch('getAllIncomes')));

        var date = new Date();
        let start = date.getTime();
        console.log('doIncome @@@1');

        let teller = 0;
        if (incomes) {
          console.log('doIncome', incomes.length);
          for (let index = 0; index < incomes.length; index++) {

            incomes[index].transaction_id = null;
            incomes[index].incomeDistributed = null;
            incomes[index].executeStatusTrees = false;

            await this.$store.dispatch('insertIncome', incomes[index]);

            if (Math.round(index/incomes.length*100) > teller) {
              console.log('doIncome', Math.round(index/incomes.length*100) + '%');
              teller = teller + 1;
            }

          }
        }

        date = new Date();
        let end = date.getTime();
        const totalTime = ((end-start)/1000);
        console.log('doIncome @@@2', totalTime);

        console.log('doIncome Finished');

        this.$store.dispatch('setLoadingApp', 0);
      },

      async doOutgoings() {

        console.log('doOutgoings');
        this.$store.dispatch('setLoadingApp', 1);

        var date = new Date();
        let start = date.getTime();
        console.log('doOutgoings @@@1');

        let result = await this.$store.dispatch('checkAllOutgoings');

        date = new Date();
        let end = date.getTime();
        const totalTime = ((end-start)/1000);
        console.log('doOutgoings @@@2', totalTime);

        console.log('doOutgoings Finished', result);

        this.$store.dispatch('setLoadingApp', 0);
        
      },

      async checkDistributionsOutgoings() {

        const start = Date.now();
        console.log('checkDistributionsOutgoings @@@1');

        const resources = await this.$store.dispatch('getAllResources');
        const allDistributions = await this.$store.dispatch('getAllOutgoingsDistributions');

        let distResourcesInDollars = 0;
        let distResourcesInSoles = 0;
        let resourceNoDist = 0;
        let resourceCourse = 0;
        let resourceNotPaid = 0;
        let resourcesError = 0;

        let teller = 0;
        const totalQueries = resources.length;

        for (let i = 0; i < resources.length; i++) {

          const resource = resources[i];

          const distributions = allDistributions.filter(
            d => d.resource_id === resource.id
          );

          // 👉 sum distributions in USD (normalized)
          let sumUSD = this.decUtil.toDec(0);

          for (const dist of distributions) {
            const amount = this.decUtil.toDec(dist.amount || 0);

            const normalized =
              resource.currency === '$'
                ? amount
                : amount.div(resource.exchangeRate || 1);

            sumUSD = sumUSD.plus(normalized);
          }

          const payment = this.decUtil.toDec(resource.payment || 0);

          if (distributions.length === 0) {
            resourceNoDist++;

          } else if (resource.type_id === 3 || resource.type_id === 8) {
            resourceCourse++;

          } else if (resource.statusResourceId === 2) {
            resourceNotPaid++;

          } else {
            // only resources with full payment

            // tolerance as decimal
            const tolerance = this.decUtil.toDec(0.05);

            if (resource.currency === '$') {

              if (sumUSD.minus(payment).abs().lt(tolerance)) {
                distResourcesInDollars++;
              } else {
                console.log(
                  'Error',
                  resource.id,
                  resource.type_id,
                  sumUSD.toNumber(),
                  payment.toNumber(),
                  resource.exchangeRate
                );
                resourcesError++;
              }

            } else if (resource.currency === 'S/.') {

              const sumSoles = sumUSD.times(resource.exchangeRate || 1);

              if (sumSoles.minus(payment).abs().lt(tolerance)) {
                distResourcesInSoles++;
              } else {
                console.log(
                  'Error',
                  resource.id,
                  resource.type_id,
                  sumUSD.toNumber(),
                  sumSoles.toNumber(),
                  payment.toNumber(),
                  resource.exchangeRate
                );
                resourcesError++;
              }
            }
          }

          // progress logging
          const progress = Math.round((i / totalQueries) * 100);
          if (progress > teller) {
            // console.log('checkDistributionsOutgoings', progress + '%');
            teller++;
          }
        }

        console.log('Total Resources', resources.length);
        console.log('Resources with no distributions', resourceNoDist);
        console.log('Courses (partial) paid)', resourceCourse);
        console.log('Resources not paid yet (exept courses)', resourceNotPaid);
        console.log('Resources with error', resourcesError);
        console.log('Correct distResourcesInDollars', distResourcesInDollars);
        console.log('Correct distResourcesInSoles', distResourcesInSoles);

        const totalTime = (Date.now() - start) / 1000;
        console.log('checkDistributionsOutgoings @@@2', totalTime);
      },

      async checkDB() {
        console.log('checkDB');

        await this.$store.dispatch('checkDB');

        console.log('checkDB Finished');

      },

      applicationIsNotPaid(updatedApplication) {
        return this.decUtil.toDec(updatedApplication.totalPrice || 0)
        .minus(updatedApplication.amountPaidApplication || 0)
        .abs()
        .gt(0.05)
      },

      getOpenAmount(updatedApplication) {
        return this.decUtil.toDec(updatedApplication.totalPrice || 0)
        .minus(updatedApplication.amountPaidApplication || 0)
        .toFixed(2)
      },

      async deleteApplication(app) {
        this.$store.dispatch('setLoadingApp', 1);
        await this.$store.dispatch('deleteApplication', app.id);
        this.dialogApplication = false;
        this.$store.dispatch('loadApplications', true);
        this.$store.dispatch('successMessage', 'Agency application removed');
        this.$store.dispatch('setLoadingApp', 0);
      },

      formatChargeAmount(charge) {
        if (charge.amount === null || charge.amount === '') return;

        const value = Number(charge.amount);

        if (charge.currency === '$') {
          charge.amount = value.toFixed(2);
        } else {
          charge.amount = Math.round(value);
        }
      },

      openPreferences() {
        this.itemsPerPageNew = this.itemsPerPage;
        this.showCurrencyNew = this.showCurrency;

        console.log('OPEN PREFS', this.$store.state.userPreferencesDashboard);
        console.log('SETTING LOCAL', this.activeTypesLocal);

        const prefs = this.$store.state.userPreferencesDashboard?.activeTypes;

        this.activeTypesLocal = prefs
          ? [...prefs]
          : ['project', 'accommodation', 'spanish', 'tour'];

        this.dialog_preferences = true;
      },
      
    },
}
</script>

<style>

    v-navigation-drawer--fixed {
      z-index: 9999 !important;
    }

    th {
      vertical-align: top;
    }

    .invoiceButtons {
      position: fixed;
      top: calc(((100% - 297mm)/2) + 150px);
      left: calc(((100% - 210mm)/2) - 70px);
    }

    .invoiceControlPanel {
      position: fixed;
      top: calc(((100% - 297mm)/2) + 150px);
      right: calc(((100% - 210mm)/2) - 320px);
    }

    @media only screen and (max-width: 1000px) {
      .invoiceButtons {
        right: 10px;
      }
    }

    @media only screen and (max-width: 1200px) {
      .invoiceControlPanel {
        right: 10px;
      }
    }

</style>